import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// founders images
import mrImg from "../assets/Header-Images/mrRajeshImg.jpeg";
import mrsImg from "../assets/Header-Images/mrsimg_new.jpg";

//prducts images
import prod1Img from "../assets/ProductsImages/prod1.jpg";
import prod2Img from "../assets/ProductsImages/prod2.jpg";
import prod3Img from "../assets/ProductsImages/prod3.jpg";
import prod4Img from "../assets/ProductsImages/prod4.jpg";
// import prod5Img from "../assets/ProductsImages/prod5.jpg";
import prod6Img from "../assets/ProductsImages/prod6.jpg";
import prod7Img from "../assets/ProductsImages/prod7.jpg";
import prod8Img from "../assets/ProductsImages/prod8.jpg";
import prod9Img from "../assets/ProductsImages/prod9.jpg";
import prod10Img from "../assets/ProductsImages/prod10.jpg";
import prod11Img from "../assets/ProductsImages/prod11.jpg";
import prod12Img from "../assets/ProductsImages/prod12.jpg";
import prod13Img from "../assets/ProductsImages/prod13.jpg";
import prod14Img from "../assets/ProductsImages/prod14.jpg";
import prod15Img from "../assets/ProductsImages/prod15.jpg";
// import prod16Img from "../assets/ProductsImages/prod16.jpg";
import GLOPOUSHAK from "../assets/ProductsImages/GLOPOUSHAK-RED.png";
import prod17Img from "../assets/ProductsImages/prod17.jpg";
// import prod18Img from "../assets/ProductsImages/prod18.jpg";
import PENDAMAX32 from "../assets/ProductsImages/PENDAMAX32.png";
import prod19Img from "../assets/ProductsImages/prod19.jpg";
import prod20Img from "../assets/ProductsImages/prod20.jpg";
import prod21Img from "../assets/ProductsImages/prod21.jpg";
import prod22Img from "../assets/ProductsImages/prod22.jpg";
import prod23Img from "../assets/ProductsImages/prod23.jpg";
import prod24Img from "../assets/ProductsImages/prod24.jpg";
import prod25Img from "../assets/ProductsImages/prod25.jpg";
import prod26Img from "../assets/ProductsImages/prod26.jpg";
import prod27Img from "../assets/ProductsImages/prod27.jpg";
// import prod28Img from "../assets/ProductsImages/prod28.jpg";
import GLYDER from "../assets/ProductsImages/GLYDER.png";
import prod29Img from "../assets/ProductsImages/prod29.jpg";
import prod30Img from "../assets/ProductsImages/prod30.jpg";
import prod31Img from "../assets/ProductsImages/prod31.jpg";
import prod32Img from "../assets/ProductsImages/prod32.jpg";
import prod33Img from "../assets/ProductsImages/prod33.jpg";
import prod34Img from "../assets/ProductsImages/prod34.jpg";
import prod35Img from "../assets/ProductsImages/prod35.jpg";
import prod36Img from "../assets/ProductsImages/prod36.jpg";
import prod37Img from "../assets/ProductsImages/prod37.jpg";
// import prod38Img from "../assets/ProductsImages/prod38.jpg";
import Akira from "../assets/ProductsImages/Akira.png";
import prod39Img from "../assets/ProductsImages/prod39.jpg";
import prod40Img from "../assets/ProductsImages/prod40.jpg";
import prod41Img from "../assets/ProductsImages/prod41.jpg";
import prod42Img from "../assets/ProductsImages/prod42.jpg";
import prod43Img from "../assets/ProductsImages/prod43.jpg";
import prod44Img from "../assets/ProductsImages/prod44.jpg";
// import prod45Img from "../assets/ProductsImages/prod45.jpg";
import TEMBOG from "../assets/ProductsImages/TEMBO-G.png";
import prod46Img from "../assets/ProductsImages/prod46.jpg";
import prod47Img from "../assets/ProductsImages/prod47.png";
import prod48Img from "../assets/ProductsImages/prod48.jpg";
import prod49Img from "../assets/ProductsImages/prod49.jpg";
import prod50Img from "../assets/ProductsImages/prod50.jpg";
import prod51Img from "../assets/ProductsImages/prod51.jpg";
import prod52Img from "../assets/ProductsImages/prod52.jpg";
import prod53Img from "../assets/ProductsImages/prod53.jpg";
import prod54Img from "../assets/ProductsImages/prod54.jpg";
import prod55Img from "../assets/ProductsImages/prod55.jpg";
import prod56Img from "../assets/ProductsImages/prod56.jpg";
import prod57Img from "../assets/ProductsImages/prod57.jpg";
import prod58Img from "../assets/ProductsImages/prod58.jpg";
import prod59Img from "../assets/ProductsImages/prod59.jpg";
import prod60Img from "../assets/ProductsImages/prod60.jpg";
// import prod61Img from "../assets/ProductsImages/prod61.jpg";
import Danger from "../assets/ProductsImages/Danger.png";
import prod62Img from "../assets/ProductsImages/prod62.jpg";
import prod63Img from "../assets/ProductsImages/prod63.jpg";
import prod64Img from "../assets/ProductsImages/prod64.jpg";
import prod65Img from "../assets/ProductsImages/prod65.jpg";
import prod66Img from "../assets/ProductsImages/prod66.jpg";
import prod67Img from "../assets/ProductsImages/prod67.jpg";
import prod68Img from "../assets/ProductsImages/prod68.jpg";
// import prod69Img from "../assets/ProductsImages/prod69.jpg";
import GLOQUAT from "../assets/ProductsImages/GLOQUAT.png";
import prod70Img from "../assets/ProductsImages/prod70.jpg";
// import prod71Img from "../assets/ProductsImages/prod71.jpg";
import THAI71 from "../assets/ProductsImages/THAI-71.png";
import prod72Img from "../assets/ProductsImages/prod72.jpg";
import prod73Img from "../assets/ProductsImages/prod73.jpg";
import prod74Img from "../assets/ProductsImages/prod74.jpg";
import prod75Img from "../assets/ProductsImages/prod75.jpg";
// import prod76Img from "../assets/ProductsImages/prod76.jpg";
import RAFTAR from "../assets/ProductsImages/RAFTAR.png";
import prod77Img from "../assets/ProductsImages/prod77.jpg";
import prod78Img from "../assets/ProductsImages/prod78.jpg";
// import prod79Img from "../assets/ProductsImages/prod79.jpg";
import SILK from "../assets/ProductsImages/SILK.png";
import prod80Img from "../assets/ProductsImages/prod80.jpg";
import prod81Img from "../assets/ProductsImages/prod81.jpg";
import prod82Img from "../assets/ProductsImages/prod82.jpg";
import prod83Img from "../assets/ProductsImages/prod83.jpg";
import prod84Img from "../assets/ProductsImages/prod84.jpg";
import INACTIVE from "../assets/ProductsImages/INACTIVE.png";
import CARGO from "../assets/ProductsImages/CARGO.png";
import BHUMIZ from "../assets/ProductsImages/BHUMIZ.png";
import MIRAN from "../assets/ProductsImages/MIRAN.png";
import AUXIL from "../assets/ProductsImages/AUXIL.png"
import FLOTON from "../assets/ProductsImages/FLOTON.png";
import LOGIC from "../assets/ProductsImages/LOGIC.png";
import ULTRA from "../assets/ProductsImages/ULTRA.png";
import Testimonial from "../Components/Testimonials";

const resources = {
  en: {
    translation: {
      home: "Home",
      about: "About Us",
      products: "Products ▼",
      founders: "Founders",
      blog: "Blogs",
      contact: "Contact Us",
      testimonials: "Testimonials",

      select_language: "Select Language",
      aboutUs: {
        badge: "About Us",
        title: "Globe International Crop Science",
        subtitle:
          "Cultivating a Sustainable Future with Globe International Crop Science",
        description1:
          "Globe International Crop Science is a team of experienced and dedicated professionals who aim to provide farmers with modern and innovative products that will increase their agricultural productivity. We are ISO certified and the leading Manufacturer of Crop Protection Solutions and Growth Promoters in M.P., Chhattisgarh, Punjab and Uttar Pradesh.",
        description2:
          "The business was established in 2018 and presently operates in three states: Madhya Pradesh, Chhattisgarh, Punjab and Uttar Pradesh. It has a vast network of 150,000 farmers and more than 500 distributors, and we offer a wide variety of more than 90 Products.",
      },
      aboutUsTwo: {
        badge: "About Us",
        title: "Globe International Crop Science",
        subtitle:
          "Cultivating a Sustainable Future with Globe International Crop Science",
        description1:
          "Globe International Crop Science is a team of experienced and dedicated professionals who aim to provide farmers with modern and innovative products that will increase their agricultural productivity. We are ISO certified and the leading Manufacturer of Crop Protection Solutions and Growth Promoters in M.P., Chhattisgarh, Punjab and Uttar Pradesh.",
        description2:
          "The business was established in 2018 and presently operates in three states: Madhya Pradesh, Chhattisgarh, Punjab and Uttar Pradesh. It has a vast network of 150,000 farmers and more than 500 distributors, and we offer a wide variety of more than 90 Products.",
        reasons: [
          {
            h1: "Our Mission",
            p: "WE CARE FOR YOUR FIELD – ensuring you yield the best harvest year after year. With every growing need in the agriculture sector, we provide innovative solutions to our farmers to help them develop the best yield year after year.",
          },
          {
            h1: "Our Vision",
            p: "Our vision is to supply our farmers with specific, high-quality Herbicides, Fungicides, Pesticides, and Plant Growth Promoters in India to maximize crop yield.",
          },
          {
            h1: "Our Values",
            p: `Farmers are the foundation of our food system, and we at Globe International Crop Science acknowledge the challenges posed by pests, illnesses, a changing environment, and the agriculture sector's ever-expanding needs. We share your passion and are here to help you grow greater yields and healthier crops using our innovative products.`,
          },
        ],
      },
      whyChooseUs: {
        title: "Why Choose Us",
        reasons: [
          {
            iconColor: "#4BAF47",
            title: "Supporting Farmers",
            description:
              "Our products are made to help you increase productivity and profit because they are specific to the soil and climate of India.",
          },
          {
            iconColor: "#4BAF47",
            title: "Trusted Products",
            description:
              "Our Products are created by professionals to make sure that your crop receives the best care.",
          },
          {
            iconColor: "#4BAF47",
            title: "Consistent Innovation",
            description:
              "Our research team is always coming up with new ideas, to meet the demands.",
          },
          {
            iconColor: "#4BAF47",
            title: "Extensive Network",
            description:
              "With an extensive network, we ensure prompt delivery of our products to clients across M.P. , Chhattisgarh and Punjab.",
          },
        ],
      },
      contactForm: {
        title: "Leave a Message",
        topHeading:
          "We are here to assist you. Fill out the form and get in touch.",
        namePH: "Your Name",
        phonePH: "Phone Number",
        emailPH: "Email Address",
        subjectPH: "subject",
        textPH: "Write a Message",
        sendButton: "  Send a Message",
        cName: "GLOBE INTERNATIONAL CROP SCIENCE",
        ISO: "An ISO 9001:2015 Certified Company",
        address:
          "6-6-99, GROUND FLOOR, SAI BABA NAGAR, KATTEDAN, KATEDHAN, RAJENDRANAGAR, RANGAREDDY, TELANGANA 500019",
      },
      foundersDetails: {
        title: "The Visionary Leaders Behind Our Mission",
        topHeading:
          "With the guidance and vision of our distinguished founders, <strong>Mr. Rajesh Agrawal</strong> and <strong>Mrs. Kiran Agrawal</strong>, we at <strong>Globe International Crop Science</strong> remain committed to our mission of a healthy and productive farming industry. Together, they have built a company that farmers trust. Their continuous dedication and extensive knowledge of agriculture have helped the business establish itself as a reliable brand in M.P., Punjab and Chhattisgarh for crop protection solutions.",
        reasons: [
          {
            name: "Mr. Rajesh Agrawal",
            title: "Founder & Visionary Leader",
            image: mrImg, // Replace with actual image URL
            description:
              "Mr. Rajesh Agrawal has years of experience in the agriculture industry and a visionary approach. He is dedicated to providing farmers with crop solutions that are innovative, sustainable, and focused on results. His strategic thinking and extensive knowledge of the difficulties farmers encounter have been crucial in establishing Globe International Crop Science as a trustworthy agricultural partner.",
          },
          {
            name: "Mrs. Kiran Agrawal",
            title: "Co-Founder & Director",
            image: mrsImg, // Replace with actual image URL
            description:
              "Is highly creative with upcoming technologies and solutions. She believes that every farming comes with a different story, but the moral of the story should be the same, that is GROWTH.",
          },
        ],
      },

      productsData: {
        title: "Our Products",
        contactHeading: "Enter Your Contact Number",
        contactMsg: "We will send your enquiry to our sales team via WhatsApp.",
        btntext: "Send Enquiry",
        enquiryBtn: "Enquiry Now",
        reasons: [
          {
            id: 1,
            name: "TRIZOXY",
            scientificName:"Azoxystrobin 16.7% Tricyclazole 33.3% SC",
            category: "Fungicides",
            description:
              "TRIZOXY is a fungicidal combination used for the control of Leaf Blast, Sheath Blight, and Brown Spot diseases in paddy crops.",
            dosage: "200 ml per acre",
            Packaging: "1 ltr, 400ml, 200ml",
            image: prod1Img,
          },
          {
            id: 2,
            name: "ELECTRO POWER",
            scientificName:"AZOXYSTROBIN 2.5% THIOPHANATE METHYL 11.25%+ THIAMETHOXAM 25% FS",
            category: "Fungicides",
            description:
              "ELECTRO POWER is a combination of insecticide and fungicide used as a seed treatment in soybean crops. It effectively controls diseases such as Fusarium root rot, Rhizoctonia seedling blight, and Pythium seedling blight, as well as pests like shoot fly, white grub, and termites.",
            dosage: "200ml / quintal of seed treatment",
            Packaging: "1 ltr, 400ml, 200ml",
            image: prod2Img,
          },
          {
            id: 3,
            name: "SUPER TARA",
            scientificName:"THIAMETHOXAM 25% WG",
            category: "Insecticides/Pesticides",
            description:
              "It is a versatile systemic insecticide with strong stomach and contact activity. It effectively protects plants from various pests.",
            dosage: "20 grams per pump",
            Packaging: "100 gm, 250 gm, 500 gm",
            image: prod3Img,
          },
          {
            id: 4,
            name: "CLEAR",
            scientificName:"CARBENDAZIM 12% MANCOZEB 83% WP",
            category: "Fungicides",
            description:
              "CLEAR is a soluble powder that acts as a highly effective protective and fungicidal agent. It offers long-lasting protection against fungal infections and is also suitable for seed treatment.",
            dosage: "250-300 grams per acre",
            Packaging: "100 gm, 250 gm, 500 gm, 1 kg",
            image: prod4Img,
          },
          // {
          //   id: 5,
          //   name: "GLO POUSHAK",
          //   scientificName:"ACTIVE CONSTITUENTS CYTOKINING & ENZYME",
          //   category: "Plant Growth Promoter",
          //   description:
          //     "GLO POUSHAK is a highly effective plant growth regulator. It contains Gibberellic Acid 0.001% as an active ingredient. It acts as a synergistic element with plant metabolism, promoting overall plant growth. It enhances enzymatic activity and boosts the internal metabolic processes of the plant, leading to improved physiological efficiency. This ultimately increases the quality and yield of the crop.",
          //   dosage: "180 to 250 ml per acre",
          //   Packaging: "500 ml, 1 Ltr",
          //   image: prod5Img,
          // },
          {
            id: 6,
            name: "SPARK",
            category: "Plant Growth Promoter",
            scientificName:"Plant Growth Regulators",
            description:
              "SPARK is a highly effective plant growth regulator that promotes root development, enhances seedling vigor, and encourages flowering. It helps reduce fruit and flower drop, increases the number of branches, accelerates germination, and significantly boosts crop yield. It also enhances the stimulative power of plants.",
            dosage: "180 to 250 ml per acre",
            Packaging: "500 ml, 1 Ltr.",
            image: prod6Img,
          },
          {
            id: 7,
            name: "DOMIS",
            scientificName:"SODIUM ACIFLUORFEN 16.5% + CLODINA PROPARGYL 8%EC",
            category: "Herbicides",
            description:
              "DOMIS is a selective emulsifiable concentrate herbicide used to control grassy and broadleaf weeds in soybean crops. It provides effective weed management to support healthy crop growth.",
            dosage: "400 ml per acre",
            Packaging: "200 ml, 400 ml, 1 liter",
            image: prod7Img,
          },
          {
            id: 9,
            name: "DAMAGE",
            scientificName:"DELTAMETHRIN 11% EC",
            category: "Insecticides/Pesticides",
            description:
              "DAMAGE is a highly effective insecticide used for the control of American bollworm, spotted bollworm, pink bollworm, Spodoptera litura, and sap-sucking pests such as aphids, jassids, and whiteflies. It is considered one of the most efficient and superior synthetic pyrethroids. It effectively controls American bollworm larvae, fruit borers, stem borers, and stem flies that damage crops like cotton, rice, sorghum, sugarcane, soybean, and vegetables. DAMAGE kills pests on contact, providing immediate and lasting protection to crops.",
            dosage: "80 to 100 ml per pump",
            Packaging: "1 Ltr, 500 ml",
            image: prod9Img,
          },
          {
            id: 10,
            name: "MAPROTAP",
            scientificName:"CARTAP HYDROCHLORIDE 50% SP",
            category: "Insecticides/Pesticides",
            description:
              "MAPROTAP is an insecticide containing Cartap Hydrochloride as its active ingredient. It is used to control a variety of pests in crops by disrupting the nervous system of insects.",
            dosage: "20 grams per pump 400 grams per acre",
            Packaging: "  250 gm, 500 gm",
            image: prod10Img,
          },
          {
            id: 12,
            name: "KIR-TAP",
            scientificName:"CARTAP HYDROCHLORIDE 4% GR",
            category: "Insecticides/Pesticides",
            description:
              "KIR-TAP is an insecticide used to control pests in rice and sugarcane fields. It is a low-toxicity, low-residue insecticide that is safe for the environment. Cartap Hydrochloride 4% GR works through contact, ingestion, and systemic action through the plant. It effectively paralyzes chewing and sucking pests and controls all stages of insects (egg, larva, adult).",
            dosage: "4 kg per acre",
            Packaging: "4 kg Bag",
            image: prod12Img,
          },
          // {
          //   id: 13,
          //   name: "ATTOM CTPR",
          //   category: "Insecticides/Pesticides",
          //   description:
          //     "TRIZOXY is a fungicidal combination used for the control of Leaf Blast, Sheath Blight, and Brown Spot diseases in paddy crops.",
          //   dosage: "20 grams per pump",
          //   Packaging: "115 ml, 230 ml",
          //   image: prod13Img,
          // },
          {
            id: 14,
            name: "LOCKER",
            scientificName:"IMAZETHAPYR 10% SL",
            category: "Herbicides",
            description:
              "LOCKER is a versatile and selective herbicide that is absorbed by the leaves and roots of plants, moving systematically throughout the plant. It provides effective control of grass and broadleaf weeds in soybean and groundnut (peanut) crops. It is applied post-emergence when weeds are in the 2-4 leaf stage or when the crop is 7-21 days old.",
            dosage: " 300 ml per acre, mixed with 200-240 liters of water and sprayed.",
            Packaging: "250ml",
            image: prod68Img,
          },
          {
            id: 15,
            name: "COR-EX",
            scientificName:"Chlorantrahiliprole 18.5% W/W SC",
            category: "Insecticides/Pesticides",
            description: `COR-EX is a unique anthranilic diamide insecticide with a broad-spectrum action. It is highly effective in controlling various pests on crops such as paddy, cabbage, cotton, sugarcane, tomato, chili, soybean, brinjal (eggplant), pigeon pea, chickpea, black gram, bitter gourd, okra, maize, green gram, and groundnut.`,
            dosage: "50 ml per acre",
            Packaging: "60 ml, 150 ml, 300 ml",
            image: prod15Img,
          },
          {
            id: 16,
            name: "GLO POUSHAK",
            scientificName:"Gibberellic Acid 0.001% L",
            category: "Plant Growth Promoter",
            description: `GLO POUSHAK is a highly effective plant growth regulator. It contains Gibberellic Acid 0.001% as an active ingredient. It acts as a synergistic element with plant metabolism, promoting overall plant growth. It enhances enzymatic activity and boosts the internal metabolic processes of the plant, leading to improved physiological efficiency. This ultimately increases the quality and yield of the crop.`,
            dosage: "180 to 250 ml per acre.",
            Packaging: "500 ml, 1 Ltr.",
            image: GLOPOUSHAK,
          },
          {
            id: 17,
            name: "KINGA-CHINGA",
            scientificName:"SULPHUR 65% TEBUCONAZOLE 10% WG",
            category: "Fungicides",
            description: `KINGA-CHINGA is an effective fungicide that controls Powdery Mildew, Fruit Rot, and Leaf Spot in chili, as well as Pod Blight in soybean. It works by inhibiting steroid demethylation (ergosterol biosynthesis) in fungi.`,
            dosage: "300 to 350 grams per acre.",
            Packaging: "100 gm, 250 gm, 500 gm, and 1 kg.",
            image: prod17Img,
          },
          {
            id: 18,
            name: "PENDAMAX-32",
            scientificName:"PENDIMETHALIN 30% + IMAZETHAPYR 2% EC",
            category: "Herbicides",
            description: `Pendamax-32 is a selective herbicide formulated with 30% Pendimethalin and 2% Imazethapyr as active ingredients. It effectively controls perennial grasses, reeds, and broadleaf weeds that grow alongside crops. This herbicide is specifically recommended for use in soybean crops to maintain a weed-free field and promote healthy crop growth.`,
            dosage: "1 liter per acre",
            Packaging: "500 ml, 1 liter",
            image: PENDAMAX32,
          },
          {
            id: 19,
            name: "GLO-GRIP",
            scientificName:"Metsulfuron Methyl 20% WP",
            category: "Herbicides",
            description: `Glo-Grip is a post-emergence herbicide belonging to the sulfonylurea family. It is highly effective in controlling broadleaf weeds, primarily in wheat, transplanted rice, and sugarcane crops. This herbicide works by inhibiting cell division in weeds, ensuring a weed-free field and promoting healthy crop growth.`,
            dosage: "8 grams per acre",
            Packaging: "8grams",
            image: prod19Img,
          },
          {
            id: 20,
            name: "GLOQUAT",
            scientificName:"PARAQUAT DICHLORIDE 24% SL",
            category: "Herbicides",
            description: `GLOQUAT is a broad-spectrum, non-selective, and contact herbicide containing 24% Paraquat Dichloride AI. It effectively controls a wide range of broadleaf weeds and grasses. It is used as a post-emergence directed application and as a pre-plant application in various crops. GLOQUAT works by producing superoxide, which damages cell membranes and cytoplasm during photosynthesis.`,
            dosage: "750 to 1000 ml per acre Mix with 200 liters of water per acre.",
            Packaging: "500 ml, 1 Ltr.",
            image: GLOQUAT,
          },
          {
            id: 21,
            name: "SUPLEX",
            scientificName:"SULPHUR 80% WDG",
            category: "Fungicides",
            description: `SUPLEX is a contact fungicide containing 80% Sulphur by weight along with other auxiliary components. Its fine granules quickly dissolve in water and spread evenly across the field, ensuring effective coverage. It is highly effective in controlling Powdery Mildew and Mites in crops.`,
            dosage: "5 to 10 kg per acre",
            Packaging: "3 kg",
            image: prod21Img,
          },
          {
            id: 22,
            name: "ZUZO/AKIRA",
            scientificName:"Chlorantraniliprole 9.3% + Lambdacyhalothrin 4.6% ZC",
            category: "Insecticides/Pesticides",
            description: `ZUZO/AKIRA combines two powerful chemicals used in insecticides to effectively target a wide range of pests. It is a broad-spectrum foliar insecticide suitable for use on crops such as cotton, soybean, mung bean, rice, and eggplant.

Chlorantraniliprole is a systemic insecticide absorbed by plants and kills pests that consume them. It disrupts the muscle function of pests, leading to paralysis and eventual death.
Lambdacyhalothrin is a contact insecticide that kills pests upon contact. It interferes with the pest's nervous system, causing paralysis and death.`,
            dosage: "80 to 100 ml per acre",
            Packaging: "100 ml, 250 ml, 500 ml",
            image: prod22Img,
          },
//           {
//             id: 23,
//             name: "CYPER STAR",
//             category: "Insecticides/Pesticides",
//             description: `CYPER STAR is a synthetic pyrethroid insecticide. It is highly effective in controlling:

// Bollworms: American bollworm
// Borers: Fruit borer, stem borer, and shoot fly
// This insecticide kills pests instantly upon contact. It is widely used on crops such as soybean, rice, cotton, chickpea, and vegetables to prevent pest infestations.
// `,
//             dosage: "40-50 ml per pump",
//             Packaging: "1 Ltr, 500 ml",
//             image: prod23Img,
//           },
          {
            id: 24,
            name: "SHINE",
            scientificName:"LAMBDACYHALOTHRIN 5% EC",
            category: "Insecticides/Pesticides",
            description: `SHINE is a synthetic pyrethroid insecticide that effectively controls a wide range of pests. It has proven to be useful in managing aphids to some extent and is highly effective against pests like aphids, Colorado beetles, larvae, cockroaches, mosquitoes, and flies. SHINE can be used on all types of crops, including soybeans, cotton, rice, and all kinds of vegetables such as wheat, chickpea, moong, urad, pigeon pea, garlic, ginger, tomato, chili, potato, and more.
`,
            dosage: "35 to 40 ml per pump",
            Packaging: "1 Ltr, 500 ml",
            image: prod24Img,
          },
          {
            id: 25,
            name: "TAKITO",
            scientificName:"QUIZALOFOP-ETHYL 10% EC",
            category: "HERBICIDES",
            description: `Takito is a selective post-emergence herbicide containing Quizalofop-Ethyl 10% EC. It is highly effective in controlling grassy weeds in crops like Moong, Urad, and Soybean. Takito specifically targets narrow-leaved (grassy) weeds, ensuring a clean and healthy crop environment.`,
            dosage: "25 to 30 ml per pump",
            Packaging: " 100ml, 250ml, 500ml, 1 Ltr.",
            image: prod70Img,
          },
          {
            id: 26,
            name: "KITO",
            scientificName:"BIO PRODUCT",
            category: "Insecticides/Pesticides",
            description: `KITO is highly effective against chewing and sucking pests and caterpillars in crops such as moong, soybean, cotton, paddy, tomato, chickpea, maize, cabbage, brinjal, groundnut, pigeon pea, and more.`,
            dosage: "10 ml per 15 liters of water",
            Packaging: "50 ml, 100 ml, 250 ml",
            image: prod26Img,
          },
          {
            id: 27,
            name: "WEED WAAR",
            scientificName:"CLODINAFOP PROPARGYL 15% WP",
            category: "HERBICIDES",
            description: `Weed Waar is a potent herbicide containing the active ingredient Clodinafop-Propargyl along with the safener Cloquintocet-Mexyl. These components are absorbed through the leaves and provide effective control of actively growing plants. They are rapidly translocated within the plant and accumulate in the meristematic tissues. The product works by inhibiting the enzyme Acetyl CoA Carboxylase (ACC-ASE), leading to stunted growth in susceptible grass species within 48 hours of application.

Plant death occurs within 2-3 weeks. The product offers greater flexibility to growers by allowing a broad application window. It poses no limitations on crop rotation, offering enhanced flexibility for subsequent crops. Weed Waar also has an excellent environmental profile and fits well within an integrated crop management program. It has a short half-life in soil (only a few days) and a very low risk of leaching.`,
            dosage: "160 grams per acre",
            Packaging: "160 gm",
            image: prod27Img,
          },
          {
            id: 28,
            name: "GLYDER",
            scientificName:"GLYPHOSATE 41% SL",
            category: "HERBICIDES",
            description: `GLYDER is a versatile (pre-emergent) herbicide that effectively controls all types of weeds. It works systematically, reaching the roots and eliminating weeds completely.`,
            dosage: "800-1200 ml per acre",
            Packaging: "1 Ltr.",
            image: GLYDER,
          },
          {
            id: 30,
            name: "G-MIDA SUPER",
            scientificName:"IMIDACLOPRID 30.5% SC",
            category: "Insecticides/Pesticides",
            description: `G-MIDA SUPER is a systemic insecticide primarily used for termite control in buildings, both pre-construction and post-construction. It is also highly effective against sucking pests such as aphids, jassids, and whiteflies in cotton, as well as brown plant hoppers and white-backed plant hoppers in paddy crops.`,
            dosage: "10 ml per pump",
            Packaging: "100 ml, 250 ml",
            image: prod30Img,
          },
          {
            id: 31,
            name: "PROTON",
            scientificName:"PROFENOFOS 50% EC",
            category: "Insecticides/Pesticides",
            description: `PROTON is a fast-acting insecticide that works effectively upon contact and ingestion by pests. It not only kills the pests but also destroys the eggs of caterpillars from within. `,
            dosage: "300-400 ml per acre",
            Packaging: "100 ml, 250 ml, 500 ml, 1 Ltr",
            image: prod31Img,
          },
          {
            id: 33,
            name: "VAID RAJ",
            scientificName:"HUMIC ACID 100% WATER SOLUBLE",
            category: "PLANT GROWTH PROMOTER",
            description: `VAID RAJ enhances germination capacity, leading to well-structured and fully developed roots, which are essential for robust plant growth. It promotes quick seed development after seed treatment, making treated seeds more resilient to harsh weather conditions.

The treated crops maintain steady growth even under excessive or low rainfall conditions, avoiding any abnormality. This leads to balanced crop growth, improved yield, uniform quality, and a remarkable 30-40% increase in productivity.`,
            dosage: "10 to 15 grams per pump.",
            Packaging: "100 gm, 250 gm, 500 gm.",
            image: prod33Img,
          },
          {
            id: 34,
            name: "CARGO ZYME",
            scientificName:"PLANT ORGANIC ACTIVATOR",
            category: "PLANT GROWTH PROMOTER",
            description: `Cargo Zyme is a plant organic activator suitable for all types of crops. It enhances crop yield, accelerates germination, influences the enzyme system, and promotes early crop maturity.`,
            dosage: "5 to 10 kg per acre",
            Packaging: "10 kg bucket and 5 kg bag",
            image: prod34Img,
          },
          {
            id: 35,
            name: "DOLPHIN",
            scientificName:"IMPOTED Zinc Sulphate Monohydrate 33%",
            category: "PLANT GROWTH PROMOTER",
            description: `Dolphin is a Zinc Sulphate Monohydrate (Zn 33%, S-15%) fertilizer used to address zinc deficiency in crops. It enhances the synthesis of growth hormones in plants, improves the utilization of nitrogen and phosphorus, and helps maintain the soil's pH level. Dolphin promotes early greening of leaves, boosts fruit yield, and increases water retention capacity in the soil.`,
            dosage: "5 kg per acre",
            Packaging: "5 kg",
            image: prod35Img,
          },
          {
            id: 36,
            name: "GLOZYME",
            scientificName:"PLANT ORGANIC ACTIVATOR",
            category: "PLANT GROWTH PROMOTER",
            description: `Glozyme is a plant organic activator that detoxifies and rejuvenates the soil. It promotes beneficial microbial growth, supports profuse, rapid, and extensive root development, and enhances plant productivity. It encourages the plant's natural resistance against diseases, pests, and climate stress. Being an organic product, it is environmentally friendly.`,
            dosage: "5 to 10 kg per acre",
            Packaging: "10 kg bucket and 5 kg bag",
            image: prod36Img,
          },
          {
            id: 37,
            name: "TWINS-404",
            scientificName:"PROFENOFOS 40% + CYPERMETHRIN 4% E.C.",
            category: "Insecticides/Pesticides",
            description: `TWINS-404 is a versatile stomach and contact insecticide used to control bollworms in cotton and caterpillars and eggs in chickpea, soybean, and vegetable crops. It provides long-lasting control over harmful pests such as American bollworm, spotted bollworm, whitefly, and stem borer, leaf folder, green leafhopper, and Hispa in paddy. It is also effective against pests in chili and vegetable crops.`,
            dosage: "50 ml per pump",
            Packaging: "250 ml, 500 ml, and 1 liter",
            image: prod37Img,
          },
          {
            id: 38,
            name: "AKIRA",
            scientificName:"Chlorantraniliprole 9.3% + Lambdacyhalothrin 4.6% ZC",
            category: "Insecticides/Pesticides",
            description: `AKIRA combines two powerful chemicals used in insecticides to effectively target a wide range of pests. It is a broad-spectrum foliar insecticide suitable for use on crops such as cotton, soybean, mung bean, rice, and eggplant.

Chlorantraniliprole is a systemic insecticide absorbed by plants and kills pests that consume them. It disrupts the muscle function of pests, leading to paralysis and eventual death.
Lambdacyhalothrin is a contact insecticide that kills pests upon contact. It interferes with the pest's nervous system, causing paralysis and death.`,
            dosage: "80 to 100 ml per acre",
            Packaging: "100 ml, 250 ml, 500 ml",
            image: Akira,
          },
          {
            id: 39,
            name: "G-MIDA",
            scientificName:"IMIDACLOPRID 17.8% SL",
            category: "Insecticides/Pesticides",
            description: `G-MIDA is a systemic insecticide widely used for termite control in buildings, both pre-construction and post-construction. It is also effective against sucking pests in cotton and controls hoppers, aphids, jassids, and other pests in paddy crops.`,
            dosage: "15 to 20 ml per pump",
            Packaging: "100 ml, 250 ml",
            image: prod39Img,
          },
          {
            id: 40,
            name: "HUNTER",
            scientificName:"DELTAMETHRIN 2.8% EC",
            category: "Insecticides/Pesticides",
            description: `HUNTER is a highly effective synthetic pyrethroid insecticide used to control a wide range of pests, including:

Bollworms: American bollworm, spotted bollworm, pink bollworm, Spodoptera litura
Sucking Pests: Jassids, aphids, whiteflies
It is particularly effective against pests that damage crops like cotton, rice, sorghum, sugarcane, soybean, and vegetables. The insecticide works by direct contact, killing pests immediately upon exposure.`,
            dosage: "40 ml per pump",
            Packaging: "1 Ltr, 500 ml",
            image: prod40Img,
          },
          {
            id: 41,
            name: "CYPER STAR",
            scientificName:"CYPERMETHRIN 10% EC",
            category: "Insecticides/Pesticides",
            description: `CYPER STAR is a synthetic pyrethroid insecticide. It is highly effective in controlling:

Bollworms: American bollworm
Borers: Fruit borer, stem borer, and shoot fly
This insecticide kills pests instantly upon contact. It is widely used on crops such as soybean, rice, cotton, chickpea, and vegetables to prevent pest infestations.`,
            dosage: "40-50 ml per pump",
            Packaging: "1 Ltr, 500 ml",
            image: prod41Img,
          },
          {
            id: 42,
            name: "FIFO",
            scientificName:"BIO PRODUCT",
            category: "Insecticides/Pesticides",
            description: `FIFO is a unique natural and organic liquid product. It is a multi-purpose and effective bio-pesticide used for preventing caterpillars and various pests on different crops.`,
            dosage: "10 ml per 15 liters of water",
            Packaging: "50 ml, 100 ml, 250 ml",
            image: prod42Img,
          },
          {
            id: 43,
            name: "VIBER",
            scientificName:"DIAFENTHIURON 47.8% SC",
            category: "Insecticides/Pesticides",
            description: `This is a unique anthranilic diamide insecticide. It is a versatile and effective product recommended for controlling various pests on crops such as paddy, cabbage, cotton, sugarcane, tomato, chili, soybean, brinjal, pigeon pea, chickpea, black gram, bitter gourd, okra, maize, green gram, and groundnut.`,
            dosage: "50 ml per acre",
            Packaging: "100ml, 250ml",
            image: prod43Img,
          },
          {
            id: 44,
            name: "QUIZ SUPER",
            scientificName:"QUIZALOFOP-ETHYL 5% EC",
            category: "Herbicides",
            description: `Quiz Super is a herbicide used to control grassy weeds in crops like soybean, cotton, and groundnut (peanut). It is a post-emergence selective herbicide that is absorbed by the leaves and translocated throughout the plant. Quizalofop-Ethyl 5% EC inhibits the enzyme Acetyl-CoA Carboxylase (ACCase), which is essential for lipid synthesis in plants. This disruption prevents the formation of cell membranes in weeds, effectively killing them without burning, ensuring they do not regrow.`,
            dosage: "25 to 30 ml per pump",
            Packaging: "250 ml, 500 ml, 1 Ltr.",
            image: prod44Img,
          },
          {
            id: 45,
            name: "TEMBO-G",
            scientificName:"TEMBOTRIONE 34.4% W/W SC",
            category: "Herbicides",
            description: `TEMBO-G is a broad-spectrum post-emergence herbicide recommended for controlling grasses and broadleaf weeds in maize crops. It is advised to use this product in combination with a surfactant for optimal results. The active ingredient in TEMBO-G is Tembotrione.`,
            dosage: "115 ml per acre",
            Packaging: "115 ml, 230 ml",
            image: TEMBOG,
          },
          {
            id: 46,
            name: "ALTERNATE",
            scientificName:"ATRAZINE 50% W.P",
            category: "Herbicides",
            description: `ALTERNATE is a selective, broad-spectrum herbicide used to control grasses and broadleaf weeds. It is suitable for both pre-emergence and targeted post-emergence applications and belongs to the triazine group of herbicides.

It is effective as a pre-emergence herbicide in maize and sugarcane crops and can also be applied immediately after planting maize. This systemic herbicide is absorbed through the roots and leaves, ensuring comprehensive weed control.`,
            dosage: "500 grams per acre",
            Packaging: "500 grams",
            image: prod46Img,
          },
          {
            id: 47,
            name: "BENZIRO",
            scientificName:"Thiamethoxam 30% FS",
            category: "Fungicides",
            description: `BENZIRO is a versatile systemic fungicide that effectively controls early-stage sucking pests by treating seeds before sowing. It is recommended for seed treatment to manage pests such as:`,
            dosage: "400 ml per quintal of seeds",
            Packaging: "100 ml, 250 ml, 500 ml, 1 Ltr.",
            image: prod47Img,
          },
          {
            id: 48,
            name: "STODIA",
            scientificName:"Azoxystrobin 11% + Tebuconazole 18.3% SC",
            category: "Fungicides",
            description: `STODIA is a powerful combination fungicide with protective, curative, and eradicative properties. It effectively controls Powdery Mildew and Fruit Rot in chili crops.`,
            dosage: "240 to 300 ml per acre",
            Packaging: "250 ml, 500 ml, 1 Ltr.",
            image: prod48Img,
          },
          {
            id: 49,
            name: "TOP N TOP",
            scientificName:"N.P.K. 00:52:34",
            category: "Plant Growth Promoter",
            description: `Top N Top provides a balanced supply of phosphorus and potassium to plants. It promotes an increase in the number of flowers in crops and prevents the shedding of flowers and fruits.`,
            dosage: "100 grams per pump",
            Packaging: "1 kg",
            image: prod49Img,
          },
          {
            id: 50,
            name: "TOP N TOP",
            scientificName:"N.P.K. 12:61:00",
            category: "Plant Growth Promoter",
            description: `Top N Top is a fertilizer rich in Nitrogen and Phosphorus. It is used to enhance root development, strengthen stems, and increase the number of flowers and fruits in plants.`,
            dosage: "1 kg per acre",
            Packaging: "1 kg",
            image: prod50Img,
          },
          {
            id: 51,
            name: "TOP N TOP",
            scientificName:"N.P.K. 00:00:50",
            category: "Plant Growth Promoter",
            description: `Top N Top is a water-soluble fertilizer with a high potassium content. It is used to address potassium and sulfur deficiencies in crops. This fertilizer enhances plant health, boosts yield, improves the quality of flowers and fruits, strengthens plant immunity, and helps plants withstand drought conditions.`,
            dosage: "1 kg per acre",
            Packaging: "1 kg",
            image: prod51Img,
          },
          {
            id: 52,
            name: "RAFTAR PLUS",
            scientificName:"N.P.K. 19:19:19",
            category: "Plant Growth Promoter",
            description: `Raftar Plus is a new-generation, fully water-soluble imported N.P.K. product that is highly effective for foliar spray and drip irrigation. It contains balanced proportions of Nitrogen, Phosphorus, and Potassium, providing instant nutrition to plants. This fertilizer supports uniform plant growth, enhances nutrition during seed and fruit formation, aids in chlorophyll production, and increases protein content in plants.`,
            dosage: "100 grams per pump",
            Packaging: "1 kg",
            image: prod52Img,
          },
          {
            id: 53,
            name: "RAFTAR PLUS",
            scientificName:"Ν.Ρ.Κ. 13:00:45",
            category: "Plant Growth Promoter",
            description: `Raftar Plus, also known as Potassium Nitrate, is a water-soluble fertilizer containing 13% Nitrogen and 45% Potassium. It helps maintain plant greenery even at low temperatures and provides protection against drought and winter stress. This fertilizer enhances plant health and yield, improving the quality of vegetables, field crops, flowers, and fruits. It is suitable for all crops and all growth stages of the crop cycle. Raftar Plus can be used in drip irrigation and foliar applications. It is compatible with all water-soluble fertilizers.`,
            dosage: "1 kg per acre",
            Packaging: "1 kg",
            image: prod53Img,
          },
          {
            id: 54,
            name: "FORCE-505",
            scientificName:"Chlorpyrifos 50% + Cypermethrin 5% E.C.",
            category: "Insecticides/Pesticides",
            description: `FORCE-505 is a highly effective insecticide that offers powerful control over a wide range of pests. It is specially formulated to combat American bollworm, spotted bollworm, pink bollworm, Spodoptera litura, and sap-sucking pests like aphids, jassids, and whiteflies. As a superior synthetic pyrethroid, it efficiently controls American pod borer, fruit borer, stem borer, and stem flies that harm crops like cotton, paddy, sorghum, maize, soybean, and vegetables. FORCE-505 acts swiftly by killing pests on contact.`,
            dosage: "40 ml per pump",
            Packaging: " 250 ml, 500 ml, and 1 liter",
            image: prod54Img,
          },
          {
            id: 55,
            name: "GLO-QC",
            scientificName:"CYPERMETHRIN 3% QUINALPHOS 20% EC",
            category: "Insecticides/Pesticides",
            description: `GLO-QC is a highly effective contact and stomach insecticide designed to control a broad spectrum of pests. It is particularly effective against American bollworm, spotted bollworm, aphids on cotton, and stem and fruit borers on brinjal. This versatile insecticide can be used on various crops, including cotton, soybean, chickpea, and mung bean.`,
            dosage: "30-50 ml per pump",
            Packaging: "1 liter and 500 ml",
            image: prod55Img,
          },
          {
            id: 56,
            name: "KAREENA",
            scientificName:"ALPHAMETHRIN 10% EC ",
            category: "Insecticides/Pesticides",
            description: `KAREENA is an insecticide from the synthetic pyrethroid group. It is a broad-spectrum insecticide with both contact and stomach action. KAREENA delivers highly effective and quick results against pests. It efficiently controls American bollworms, fruit borers, stem borers, and stem flies, killing pests immediately upon contact.`,
            dosage: "30 ml per pump",
            Packaging: "1 Ltr, 500 ml",
            image: prod56Img,
          },
          {
            id: 57,
            name: "MISSION",
            scientificName:"EMAMECTIN BENZOATE 5% SG",
            category: "Insecticides/Pesticides",
            description: `MISSION is a new-generation bio-insecticide that enhances strength and quality while effectively preventing pest infestations. It is highly effective against borers and lepidopteran pests.`,
            dosage: "10 grams per pump",
            Packaging: "50 gm, 100 gm, 250 gm, 500 gm",
            image: prod57Img,
          },
          {
            id: 58,
            name: "DABANG",
            scientificName:"EMAMECTIN BENZOATE 5% SG",
            category: "Insecticides/Pesticides",
            description: `DABANG is a new-generation biological formulation that enhances strength and quality while preventing pest infestations. It is highly effective against thrips and Lepidoptera pests.`,
            dosage: "10 grams per pump",
            Packaging: "50 gm, 100 gm, 250 gm, 500 gm",
            image: prod58Img,
          },
          {
            id: 59,
            name: "XTREME",
            scientificName:"LAMBDA CYHALOTHRIN 4.9% CS",
            category: "Insecticides/Pesticides",
            description: `XTREME is a synthetic pyrethroid insecticide. It effectively controls a wide range of pests and is particularly useful in managing aphids. It is highly effective against:

Pests: Aphids, Colorado beetles, larvae, cockroaches, mosquitoes, and flies
This insecticide is suitable for use on all types of crops, including soybean, cotton, rice, and all kinds of vegetables.`,
            dosage: "25-30 ml per pump",
            Packaging: "1 Ltr, 500 ml",
            image: prod59Img,
          },
          {
            id: 60,
            name: "WWF",
            scientificName:"FIPRONIL 40% + IMIDACLOPRID 40% WG",
            category: "Insecticides/Pesticides",
            description: `WWF is a combination product of two chemical groups: Phenylpyrazole (Fipronil) and Neonicotinoid (Imidacloprid). The dual systemic action against pests ensures effective pest control. It is recommended for soil pests like white grubs in sugarcane. It can be applied as a soil trench treatment at any stage. WWF provides long-lasting and consistent control of pests and can effectively manage repeated white grub infestations due to its strong affinity with soil particles.`,
            dosage: "80 to 100 grams per acre",
            Packaging: "40 gm, 100 gm",
            image: prod60Img,
          },
          {
            id: 61,
            name: "DANGER",
            scientificName:"EMAMECTIN BENZOATE 1.9% EC",
            category: "Insecticides/Pesticides",
            description: `This product is a highly effective insecticide based on advanced biological research. It has shown excellent results when sprayed on all types of crops. It provides complete control over all harmful pests, such as Soybean Caterpillar, Chickpea Caterpillar, Spotted Caterpillar, Black Caterpillar, Spodoptera, American Caterpillar, Brinjal Caterpillar, and Lacha, keeping crops safe for a longer duration.`,
            dosage: "25 to 50 ml per pump",
            Packaging: "250 ml, 500 ml, 1 Ltr.",
            image: Danger,
          },
          {
            id: 62,
            name: "GLO PRID",
            scientificName:"ACETAMIPRID 20% SP",
            category: "Insecticides/Pesticides",
            description: `Glo Prid is a soluble powder that primarily controls pest infestations on cotton, various crops, and vegetables.`,
            dosage: "20 grams per pump",
            Packaging: "100 gm, 250 gm",
            image: prod62Img,
          },
          {
            id: 63,
            name: "TRILL",
            scientificName:"BIFENTHRIN 10% E.C.",
            category: "Insecticides/Pesticides",
            description: `This product affects insects through stomach and contact action. It works on the insect's nervous system by disrupting neuron function through interaction with sodium channels.`,
            dosage: "200 to 250 ml per acre",
            Packaging: "250ml, 500ml, 1 Ltr.",
            image: prod63Img,
          },
          {
            id: 64,
            name: "ROLEX",
            scientificName:"MITICIDE",
            category: "Insecticides/Pesticides",
            description: `This is a high-grade product based on advanced biological technology. It contains special biological components that act as a powerful miticide and insecticide. After application, it provides long-lasting protection for crops by effectively eliminating all types of thrips, white mites, red mites, other sucking pests, leaf miners, and more.`,
            dosage: "20-25 ml per pump",
            Packaging: "100ml, 250ml",
            image: prod64Img,
          },
          {
            id: 65,
            name: "GITHAL",
            scientificName:"CHLORPYRIFOS 20% EC",
            category: "Insecticides/Pesticides",
            description: `GITHAL is a versatile insecticide that effectively controls pests on chili and vegetable crops. It is particularly effective against:`,
            dosage: "50 ml per pump",
            Packaging: "1 Ltr, 500 ml",
            image: prod65Img,
          },
          {
            id: 66,
            name: "SELECT",
            scientificName:"Quinalphos 25% EC",
            category: "Insecticides/Pesticides",
            description: `
SELECT is a broad-spectrum organophosphatic insecticide containing 25% w/v Quinalphos as an emulsifiable concentrate. It offers a wide range of activity and demonstrates excellent initial and residual toxicity against bollworms in cotton, as well as stem borers, leaf folders, green leafhoppers, and Hispa in rice crops.`,
            dosage: "30-50 ml per pump",
            Packaging: "1 Liter and 500 ml",
            image: prod66Img,
          },
          {
            id: 67,
            name: "GLOVEG",
            scientificName:"DIAFENTHIURON 50% WP",
            category: "Insecticides/Pesticides",
            description: `GLOVEG is an insecticide from the thiourea group, functioning as both an insecticide and an acaricide through contact and stomach action. It also exhibits some ovicidal activity. It is effective in controlling whiteflies and other sucking pests, as well as mites, across a variety of crops.`,
            dosage: "25 grams per pump",
            Packaging: "25 grams",
            image: prod67Img,
          },
          {
            id: 68,
            name: "THAI-71",
            scientificName:"Ammonium Salt of Glyphosate 71% SG",
            category: "Herbicides",
            description: `With the goal of providing maximum satisfaction to our valued customers, we play a crucial role in offering high-quality, tested Glyphosate 71% SG. The provided product is formulated by our skilled professionals using superior-grade chemicals at an advanced processing unit. Known as an effective herbicide, this product is ideal for killing weeds in all types of broadleaf crops.`,
            dosage: "100 grams per pump / 1 kg per acre",
            Packaging: "100 gm",
            image: THAI71,
          },
          {
            id: 69,
            name: "WEED CLEANER",
            scientificName:"2,4-D Ethyl Ester 38% E.C.",
            category: "Herbicides",
            description: `Weed Cleaner is a safe and broad-spectrum herbicide for controlling broadleaf weeds in various crops. It is a selective, systemic herbicide from the phenoxyacetic group. In addition to effectively controlling broadleaf weeds, it also targets Cyperus species. Weed Cleaner is absorbed through the leaves and roots and is translocated within the weed plants. Ensure sufficient soil moisture at the time of application. It should be applied between 30-40 days after sowing/planting.`,
            dosage: "300 to 500 ml per acre",
            Packaging: "200 ml, 400 ml, 1 Ltr.",
            image: prod72Img,
          },
          {
            id: 70,
            name: "WEED STOPER",
            scientificName:"2, 4-D AMINE SALT 58% SL",
            category: "Herbicides",
            description: `Weed Stoper is an effective herbicide for controlling broadleaf weeds and also targets Cyperus species. It is absorbed through the leaves and roots and is translocated within the weed plants, leading to their complete control. When used at the recommended dosage, Weed Stoper or Weedmer Super does not have any adverse effects on crops.`,
            dosage: "300 to 500 ml per acre",
            Packaging: "200 ml, 400 ml, 1 Ltr.",
            image: prod73Img,
          },
           {
            id: 71,
             name: "SINGHAM",
             scientificName:"HUMIC ACID 5% + FULVIC 5% + SEAWEED EXTRACT 5%",
            category: "Plant Growth Promoter",
            description: `SINGHAM is a natural plant and yield growth enhancer based on humic acid, derived through biotechnological processes from natural sources. It is designed for both foliar spray and soil treatment. SINGHAM improves soil fertility, enhances soil structure, and ensures the easy availability of nutrients to plants.`,
            dosage: "40-50 ml per pump.",
            Packaging: "500 ml, 1 Ltr.",
            image: prod74Img,
          },
          {
            id: 72,
            name: "MAHABALI",
            scientificName:"HUMIC ACID 5% + FULVIC ACID 5% + SEAWEED EXTRACT 5%",
            category: "Plant Growth Promoter",
            description: `MAHABALI is a natural plant and yield growth enhancer based on humic acid, derived through biotechnological methods from natural sources. It is suitable for both foliar spray and soil treatment. MAHABALI enhances soil fertility, improves soil structure, and facilitates the easy availability of nutrients to plants.`,
            dosage: "50 to 60 ml per pump.",
            Packaging: "500ml, 1 Ltr.",
            image: prod75Img,
          },
          {
            id: 73,
            name: "RAFTAR",
            scientificName:"BIOSTIMULANT",
            category: "Plant Growth Promoter",
            description: `RAFTAR is a Brassinolide-based comprehensive hormone formulation designed for foliar application. It is specially developed to enhance growth and yield in crops such as cotton, pulses, oilseeds, sugarcane, bananas, soybeans, chickpeas, chilies, and all vegetables and crops. RAFTAR increases the number of flowers and fruits and prevents them from dropping. It significantly reduces the problem of pod shattering in soybeans and enhances the photosynthesis process in plants.`,
            dosage: "10 to 15 ml per pump.",
            Packaging: "250 ml, 500 ml, 1 Ltr.",
            image: RAFTAR,
          },
          {
            id: 74,
            name: "MORE",
            scientificName:"NATURAL ORGANIC",
            category: "Plant Growth Promoter",
            description: `MORE is a unique blend of proteins, vitamins, hormones, and enzymes, along with essential trace elements like iron, boron, copper, and zinc. It softens the leaves, prevents leaf curling (like ironing leaves), and protects flowers from falling. It eliminates fruit rot issues, promotes branching, encourages new growth, and consistently increases plant height. Additionally, it enhances the plant's nutrient uptake and boosts its appetite.`,
            dosage: "20 grams per pump.",
            Packaging: "100 gm.",
            image: prod77Img,
          },
          {
            id: 75,
            name: "HOLD",
            scientificName:"HEXACONAZOLE 5% SC",
            category: "Fungicides",
            description: `HOLD is a new formulation with 5% Hexaconazole in a concentrated suspension form. It is an excellent fungicide from the triazole group that protects crops from various diseases. It is used in rice, vegetables, and fruits to control Leaf Spot, Brown Leaf Spot, Blight, and Powdery Mildew in mangoes.`,
            dosage: "Mix 400 ml of HOLD per acre in 200 liters of water.",
            Packaging: "500 ml, 1 Ltr.",
            image: prod78Img,
          },
          {
            id: 76,
            name: "SILK",
            scientificName:"Silicon-Based Spreader ",
            category: "Spreaders/Activators",
            description: `SILK is a liquid formulation based on silicon. When mixed with any pesticide and sprayed, it ensures even distribution of the pesticide on the plant, resulting in reduced pest attack.`,
            dosage: "5 ml per 15 liters of water",
            Packaging: "50 ml, 100 ml, 250 ml, 500 ml, and 1 Ltr.",
            image: SILK,
          },
          {
            id: 77,
            name: "GLOVIT",
            scientificName:"WETTING AGENT",
            category: "Spreaders/Activators",
            description: `GLOVIT is an effective wetting agent that enhances the performance of pesticides, fungicides, herbicides, and other agrochemicals. It has excellent wetting power, ensuring a uniform solution with even distribution of the spray. GLOVIT helps the spray penetrate deeply into various parts of the plant, facilitates quick drying, and ensures effective coverage of the applied chemicals. It is suitable for all crops, including soybean, wheat, chickpea, green gram, black gram, pigeon pea, rice, onion, garlic, ginger, tomato, chili, cotton, potato, and more.`,
            dosage: "30-50 ml per pump",
            Packaging: "250 ml, 500 ml, 1 Ltr.",
            image: prod80Img,
          },
               {
            id: 78,
                 name: "CYPER STAR PLUS",
                 scientificName:"CYPERMETHRIN 25% EC",
            category: "Insecticides/Pesticides",
            description: `CYPER STAR PLUS is a synthetic pyrethroid group insecticide that effectively controls a wide range of pests, including American bollworm, fruit borer, stem borer, and stem fly. It acts rapidly upon contact, killing insects instantly. This insecticide is ideal for use on soybean, paddy, cotton, chickpea, and vegetables to prevent pest infestations.`,
            dosage: "25-30 ml per pump",
            Packaging: "1 liter and 500 ml",
            image: prod81Img,
          },
                {
            id: 79,
                  name: "SORA",
                  scientificName:"Thiamethoxam 12.6% + Lambda-Cyhalothrin 9.5% ZC",
            category: "Insecticides/Pesticides",
            description: `
A versatile insecticide combination with strong stomach and contact action. It is effective against aphids, jassids, thrips, leaf-eating caterpillars, borers, fruit-piercing moths, whiteflies, stem flies, and more.`,
            dosage: "80 to 100 ml per acre",
            Packaging: "250ml, 500ml, 1Ltr.",
            image: prod82Img,
          },
                 {
            id: 80,
            name: "GURU",
            scientificName:"Plant Growth Promoter",
            category: "Plant Growth Promoter",
            description: `GURU is an exceptional bio-organic product that draws organic energy from plants and makes essential nutrients available to the root zone, enabling fine roots to spread many times more into the soil. Its primary function is to increase the availability of phosphorus.`,
            dosage: "2.5 kg per acre",
            Packaging: "12 pack X 2.5 kg = 30 kg",
            image: prod83Img,
          },
                        {
            id: 81,
            name: "Bhumiz",
            scientificName: "Bhumiz (Kit content)",
            category: "Plant Growth Promoter",
            description: `● Zinc Sulphate 33%Mono.-5 kg.
●Sulphur 80%Wdg -3kg.
●Ferrous Sulphate-5kg.
●Magnesium Sulphate-8 kg.
●manganese Sulphate-1kg.
●Humic Acid-1 kg.
Total -23 kg.
Crop -all crop`,
            dosage: "1 kit/acre",
            Packaging: "23 kg",
            image: BHUMIZ,
          },
          {
            id: 82,
            name: "INACTIVE",
            scientificName: "Diclosulam 84% WDG",
            category: "Herbicides",
            description: `Diclosulam (84% WDG) is a selective, systemic, pre-emergent, and early post-emergence herbicide used to control broadleaf weeds and sedges in soybeans, peanuts (groundnut), and other crops. It inhibits the ALS enzyme, preventing cell division and weed growth.
1.Target Crops: Primarily Soyabean and Groundnut
2.Application Timing: Typically applied pre-emergence (0–3 days after sowing).`,
            dosage: "12.4 gm/acre",
            Packaging: "12.4 gm",
            image: INACTIVE,
          },
          {
            id: 83,
            name: "Cargo",
            scientificName: "Triacontanol GR 0.05% Min",
            category: "Plant Growth Promoter",
            description: `is a granular plant growth regulator (PGR) containing a minimum of 0.05% w/w Triacontanol, designed to enhance crop yields, improve root/shoot development, and boost photosynthesis. This eco-friendly, fast-acting formula stimulates cell division, aiding in better flowering and reduced fruit drop across various crops Increases chlorophyll content, improves enzyme activity, and enhances nutrient and water uptake.
1. Application: Generally applied to the soil, either mixed with fertilizers during planting or as a top dressing.
2. Dosage: Typically 5 kg per acre.
3. Target Crops: Suitable for rice (paddy), tomatoes, cotton, chilies, groundnuts, sugarcane, and other vegetables and fruits.`,
            dosage: "5 kg per acre",
            Packaging: "5 kg",
            image: CARGO,
          },
          {
            id: 84,
            name: "MIRAN",
            scientificName: "00-52-34",
            category: "Liquid water soluble",
            description: `MIRAN-00-52-34 (often referred to as MKP or Monopotassium Phosphate) is a 100% water-soluble, nitrogen-free fertilizer, high in phosphorus 
 and potassium 
 It is designed for fertigation and foliar application, making it ideal for stimulating flowering, improving fruit quality, and enhancing root development.  
composition: – Nitrogen (N): 0%
– Phosphorus (P): 52%
– Potassium (K): 34%

1.Application Methods: Drip irrigation (fertigation) and foliar spray
. 2.Timing: Best applied -during pre-bloom and post-bloom stages for maximum fruit/flower development.`,
            dosage: "Foliar Spray:  15-20 ml per liter of water and spray on leaves.",
            Packaging: "1 ltr,500 ml",
            image: MIRAN,
          },
          {
            id: 85,
            name: "AUXIL",
            scientificName: "19:19:19",
            category: "Liquid water soluble",
            description: `AUXIL(19:19:19) It supply Nitrogen, Phosphorus and Potash equally to Plant.It should be used during the early stages of plant growth. Spraying is veryeffective in improving the diminished / pale crop. It helps in increasebranching and flowering. It provides balanced nutrition to the crops in theearly growth stages. It is useful especially for healthy vegetative growth ofyoung seedling and growing plants. It prevents flower and fruit droppingresulting in more yield.
1.COMPOSITION– Nitrogen (N): 19%
– Phosphorus (P): 19%
– Potassium (K): 19%`,
            dosage: "250-300 ML/ACRE",
            Packaging: "1 LTR,500 ML",
            image: AUXIL,
          },
          {
            id: 86,
            name: "LOGIC",
            scientificName: "Zinc Oxide Suspension Concentrate 39.5% Zn",
            category: "Liquid water soluble",
            description: `LOGIC-Zinc Oxide Suspension Concentrate 39.5% Zn is a highly concentrated, liquid flowable fertilizer designed to correct zinc deficiencies in crops. It acts as a micronutrient source for essential plant functions like chlorophyll production, enzyme activation, and metabolic growth. It offers superior leaf absorption, quick uptake, and improved crop yields
1.APPLICATION-
Foliar Spray: Generally 0.5 ml - 1.5 ml per liter of water.
Soil Application: 500 ml - 1 liter per acre.`,
            dosage:
              "Foliar Spray: 0.5 ml - 1.5 ml per liter of water. Soil Application: 500 ml - 1 liter per acre.",
            Packaging: "1 LTR,500 ML",
            image: LOGIC,
          },
          {
            id: 87,
            name: "FLOTON",
            scientificName: "Calcium Magnesium Nitrate",
            category: "Liquid water soluble",
            description: `FLOTON is a highly soluble, fast-acting fertilizer providing essential calcium, nitrogen, and magnesium for enhanced chlorophyll production, photosynthesis, and strong, healthy plant growth. Ideal for fertigation or foliar spray, it prevents nutrient deficiencies like blossom end rot and improves crop quality in fruits, vegetables, and ornamentals.
Application Methods: Can be applied through fertigation (drip irrigation), soil drenching, or foliar spray.`,
            dosage: "250-300 ML/ACRE",
            Packaging: "1 LTR,500ML",
            image: FLOTON,
          },
          {
            id: 88,
            name: "ULTRA",
            scientificName: "Boron Ethanolamine",
            category: "Liquid water soluble",
            description: `ULTRA-Boron Ethanolamine 10% is a highly soluble, liquid micronutrient fertilizer providing 10% boron, essential for cell wall formation, pollen germination, and fruit set. It corrects deficiency symptoms like cracked stems, fruit rotting, and poor development.`,
            dosage: "200 ML/ACRE",
            Packaging: "1 LTR,500 ML",
            image: ULTRA,
            }
        ],
      },



       
      testimonial: {
        testimonialTitle: "What our client says",
        reasons: [
          {
            id: 1,
            name: "Pintu Rajput",
            role: "Farmer",
            content:
              "Globe International Crop Science's pesticides protected my crops from harmful insects. Now my crops are healthier and stronger!",
          },
          {
            id: 2,
            name: "Amit Sharma",
            role: "Farmer",
            content:
              "Earlier, pests used to destroy my crops, but with GICS pesticides, my crops are now safe and giving better yields!",
          },
          {
            id: 3,
            name: "Sunil Yadav",
            role: "Farmer",
            content: `Choosing the right pesticide is very important, and Globe International Crop Science’s "Corex" and "Force-505" products have provided excellent protection for my crops.`,
          },
          {
            id: 4,
            name: "Rakesh Verma",
            role: "Farmer",
            content:
              "Now I don’t have to worry about pests! GICS pesticides have helped keep my crops safe and healthy.",
          },
          {
            id: 5,
            name: "Balwan Singh Rajput",
            role: "Farmer",
            content: ` I had issues with fungal infections in my crops, but GICS "HOLD" fungicides completely solved the problem. Now my yield is better than before!`,
          },
          {
            id: 6,
            name: "Mahendra Sharma",
            role: "Farmer",
            content:
              "Crops getting damaged due to fungus is now a thing of the past. Globe International Crop Science’s fungicides saved my crops!",
          },
          {
            id: 7,
            name: "Harish Mehta",
            role: "Farmer",
            content: `  Growing healthy crops was difficult without the right fungicide, but GICS "STODIA" has made my farming safer and more productive!`,
          },
          {
            id: 8,
            name: "Suresh Tiwari",
            role: "Farmer",
            content:
              "Now my crops are safe from fungal diseases! GICS fungicides work amazingly well.",
          },
          {
            id: 9,
            name: "Arjun Kourav",
            role: "Farmer",
            content: ` Weeds used to grow rapidly in my fields, but GICS's products "TAKITO" "TEMBO-G" herbicides have completely solved the problem!`,
          },
          {
            id: 10,
            name: "Vivek Malviya",
            role: "Farmer",
            content:
              "Earlier, removing weeds took a lot of time and effort, but now with GICS herbicides, my fields remain clean and fertile.",
          },
          {
            id: 11,
            name: "Rajendra Patel",
            role: "Farmer",
            content: `Weeds no longer stop my crops from growing! GICS's "Weed Cleaner" herbicides work really well.`,
          },
          {
            id: 12,
            name: "Anil Gupta",
            role: "Farmer",
            content:
              "Globe International Crop Science’s herbicides have made my fields weed-free, and my production has increased!",
          },
          {
            id: 13,
            name: "Prashant Kourav",
            role: "Farmer",
            content: `  GICS's "Glopaushak" "More" "Singham" plant growth regulators have boosted my crop growth, making my plants greener, healthier, and stronger!`,
          },
          {
            id: 14,
            name: "Ansul Joshi",
            role: "Farmer",
            content:
              "Earlier, my crops were weak and slow-growing, but with GICS growth regulators, I now get better yields.",
          },
          {
            id: 15,
            name: "Atul Jain",
            role: "Farmer",
            content:
              "If you want your crops to grow faster and stronger, GICS growth regulators are the best choice!",
          },
          {
            id: 16,
            name: "Manoj Singh",
            role: "Farmer",
            content:
              "Globe International Crop Science’s growth regulators have strengthened my crop roots and significantly increased my yield!",
          },
          {
            id: 17,
            name: "Raghunandan Rajput",
            role: "Farmer",
            content:
              "Globe International Crop Science’s products are always reliable and high quality. They have helped keep my crops safe and productive!",
          },
          {
            id: 18,
            name: "Rohit Kushwah",
            role: "Farmer",
            content:
              "GICS has the best solutions for agriculture. Their products truly give amazing results!",
          },
          {
            id: 19,
            name: "Ranjeet Raghuvanshi",
            role: "Farmer",
            content:
              "I have been using GICS products for years, and they always give excellent results. Nothing beats them for farming!",
          },
          {
            id: 20,
            name: "Shiv Kumar",
            role: "Farmer",
            content:
              "Globe International Crop Science has made farming easier and more profitable for farmers. Their products are completely trustworthy!",
          },
        ],
      },
    },
  },
  hi: {
    translation: {
      home: "होम",
      about: "हमारे बारे में",
      products: "उत्पाद",
      founders: "संस्थापक",
      blog: "ब्लॉग",
      contact: "संपर्क करें",
      testimonials: "प्रशंसापत्र",
      select_language: "भाषा चुनें",
      aboutUs: {
        badge: "हमारे बारे में",
        title: "ग्लोब इंटरनेशनल क्रॉप साइंस",
        subtitle: "ग्लोब इंटरनेशनल क्रॉप साइंस के साथ एक सतत भविष्य की खेती",
        description1:
          "ग्लोब इंटरनेशनल क्रॉप साइंस अनुभवी और समर्पित पेशेवरों की एक टीम है जिसका लक्ष्य किसानों को आधुनिक और नवीन उत्पाद प्रदान करना है जिससे उनकी कृषि उत्पादकता बढ़े। हम आईएसओ प्रमाणित हैं और मध्य प्रदेश, पंजाब ,छत्तीसगढ़ और उत्तर प्रदेश में फसल सुरक्षा समाधान और विकास प्रोमोटर के अग्रणी निर्माता हैं।",
        description2:
          "इस व्यवसाय की स्थापना 2018 में हुई थी और वर्तमान में यह तीन राज्यों - मध्य प्रदेश,पंजाब, छत्तीसगढ़ और उत्तर प्रदेश में संचालित होता है। हमारे पास 150,000 किसानों और 500 से अधिक वितरकों का एक व्यापक नेटवर्क है, और हम 90 से अधिक उत्पादों की विस्तृत श्रृंखला पेश करते हैं।",
      },
      aboutUsTwo: {
        badge: "हमारे बारे में",
        title: "ग्लोब इंटरनेशनल क्रॉप साइंस",
        subtitle: "ग्लोब इंटरनेशनल क्रॉप साइंस के साथ एक सतत भविष्य की खेती",
        description1:
          "ग्लोब इंटरनेशनल क्रॉप साइंस अनुभवी और समर्पित पेशेवरों की एक टीम है जिसका लक्ष्य किसानों को आधुनिक और नवीन उत्पाद प्रदान करना है जिससे उनकी कृषि उत्पादकता बढ़े। हम आईएसओ प्रमाणित हैं और मध्य प्रदेश, पंजाब ,छत्तीसगढ़ और उत्तर प्रदेश में फसल सुरक्षा समाधान और विकास प्रोमोटर के अग्रणी निर्माता हैं।",
        description2:
          "इस व्यवसाय की स्थापना 2018 में हुई थी और वर्तमान में यह तीन राज्यों - मध्य प्रदेश, पंजाब ,छत्तीसगढ़ और उत्तर प्रदेश में संचालित होता है। हमारे पास 150,000 किसानों और 500 से अधिक वितरकों का एक व्यापक नेटवर्क है, और हम 90 से अधिक उत्पादों की विस्तृत श्रृंखला पेश करते हैं।",
        reasons: [
          {
            h1: "हमारा उद्देश्य",
            p: "हम रखते हैं आपके खेतों का ख्याल हर साल बेहतर फसल उपजाने में आपकी सहायता करना ही हमारा उद्देश्य है। कृषि क्षेत्र की हर नई आवश्यकता के साथ हम किसानों को नवीनतम और प्रभावशाली समाधान प्रदान करते हैं ताकि हर मौसम में बेहतर उत्पादन सुनिश्चित हो सके।",
          },
          {
            h1: "हमारा दृष्टिकोण",
            p: "हमारा लक्ष्य है कि भारत के किसानों को उच्च गुणवत्ता वाले शाकनाशी (Herbicides), कवकनाशी (Fungicides), कीटनाशी (Pesticides) और पौध वृद्धि प्रवर्तक (Plant Growth Promoters) उपलब्ध कराकर उनकी फसल की उपज को अधिकतम किया जा सके।",
          },
          {
            h1: "हमारे मूल्य",
            p: "किसान हमारे खाद्य तंत्र की नींव हैं। ग्लोब इंटरनेशनल क्रॉप साइंस में हम यह समझते हैं कि किसानों को कीटों, बीमारियों, बदलते मौसम और कृषि क्षेत्र की बढ़ती आवश्यकताओं से निरंतर जूझना पड़ता है। हम आपकी मेहनत और समर्पण को समझते हैं और आपकी फसल को अधिक उपजाऊ और स्वस्थ बनाने के लिए नवाचार से भरपूर अपने उत्पादों के साथ सदैव आपके साथ हैं।",
          },
        ],
      },
      whyChooseUs: {
        title: "हमें क्यों चुनें",
        reasons: [
          {
            iconColor: "#4BAF47",
            title: "किसानों का समर्थन",
            description:
              "हमारे उत्पाद विशेष रूप से भारत की मिट्टी और जलवायु के अनुसार बनाए गए हैं, जिससे आप अपनी उत्पादकता और लाभ बढ़ा सकते हैं।",
          },
          {
            iconColor: "#EEC044",
            title: "विश्वसनीय उत्पाद",
            description:
              "हमारे उत्पाद पेशेवरों द्वारा बनाए गए हैं ताकि आपकी फसल को सर्वोत्तम देखभाल मिल सके।",
          },
          {
            iconColor: "#C5CE38",
            title: "निरंतर नवाचार",
            description:
              "हमारी अनुसंधान टीम हमेशा नई मांगों को पूरा करने के लिए नए विचारों के साथ आती रहती है।",
          },
          {
            iconColor: "#1F1E17",
            title: "व्यापक नेटवर्क",
            description:
              "हम व्यापक नेटवर्क के माध्यम से मध्य प्रदेश ,पंजाब और छत्तीसगढ़ में अपने उत्पादों की त्वरित डिलीवरी सुनिश्चित करते हैं।",
          },
        ],
      },
      contactForm: {
        title: "एक संदेश छोड़ें",
        topHeading:
          "हम आपकी सहायता के लिए यहां हैं। फॉर्म भरें और हमसे संपर्क करें।",
        namePH: "आपका नाम",
        phonePH: "फोन नंबर",
        emailPH: "ईमेल पता",
        subjectPH: "विषय",
        textPH: "एक संदेश लिखें",
        sendButton: "संदेश भेजें",
        cName: "ग्लोब इंटरनेशनल क्रॉप साइंस",
        ISO: "आईएसओ 9001:2015 प्रमाणित कंपनी",
        address:
          "पंजी. कार्यालय: 117, वैभव चेम्बर, 7/1, उषागंज छावनी, इंदौर (म.प्र.) भारत 452001",
      },
      foundersDetails: {
        title: "हमारे मिशन के पीछे दूरदर्शी नेता",
        topHeading:
          "हमारे सम्माननीय संस्थापकों <strong>श्री राजेश अग्रवाल</strong> और <strong>श्रीमती किरण अग्रवाल</strong> के मार्गदर्शन और दृष्टिकोण के साथ, <strong>ग्लोब इंटरनेशनल क्रॉप साइंस</strong> एक स्वस्थ और उत्पादक कृषि उद्योग के अपने मिशन के लिए प्रतिबद्ध है। उन्होंने मिलकर एक ऐसा संगठन बनाया है जिस पर किसान विश्वास करते हैं। कृषि में उनका निरंतर समर्पण और गहन ज्ञान ने मध्यप्रदेश, पंजाब और छत्तीसगढ़ में फसल सुरक्षा समाधानों के लिए इस व्यवसाय को एक विश्वसनीय ब्रांड के रूप में स्थापित करने में मदद की है।",
        reasons: [
          {
            name: "श्री राजेश अग्रवाल",
            title: "संस्थापक एवं दूरदर्शी नेता",
            image: mrImg, // यथार्थ छवि URL डालें
            description:
              "श्री राजेश अग्रवाल के पास कृषि उद्योग में वर्षों का अनुभव है और वे दूरदर्शी सोच रखते हैं। वे किसानों को नवाचार, स्थिरता और परिणामों पर केंद्रित फसल समाधान प्रदान करने के लिए समर्पित हैं। उनकी रणनीतिक सोच और किसानों की समस्याओं की गहरी समझ ने ग्लोब इंटरनेशनल क्रॉप साइंस को एक भरोसेमंद कृषि साझेदार के रूप में स्थापित करने में महत्वपूर्ण भूमिका निभाई है।",
          },
          {
            name: "श्रीमती किरण अग्रवाल",
            title: "सह-संस्थापक एवं निदेशक",
            image: mrsImg, // यथार्थ छवि URL डालें
            description:
              "वे नई तकनीकों और समाधानों को लेकर अत्यंत रचनात्मक हैं। उनका मानना है कि हर खेती की अपनी एक अलग कहानी होती है, लेकिन हर कहानी का उद्देश्य एक ही होना चाहिए – और वह है ‘विकास’।",
          },
        ],
      },
      productsData: {
        title: "हमारे उत्पाद",
        contactHeading: "अपना संपर्क नंबर दर्ज करें",
        contactMsg:
          "हम आपकी पूछताछ को हमारी बिक्री टीम को WhatsApp के माध्यम से भेजेंगे।",
        btntext: "पूछताछ भेजें",
        enquiryBtn: "अभी पूछताछ करें",
        reasons: [
          {
            id: 1,
            name: "TRIZOXY",
            scientificName:"Azoxystrobin 16.7% + Tricyclazole 33.3% SC",
            category: "Fungicides",
            description:
              "TRIZOXY एक फफूंदनाशी संयोजन है जिसका उपयोग धान की फसल में लीफ ब्लास्ट, शीथ ब्लाइट और ब्राउन स्पॉट रोगों के नियंत्रण के लिए किया जाता है।",
            dosage: "200 मिलीलीटर प्रति एकड़",
            Packaging: "1 लीटर, 400 मिलीलीटर, 200 मिलीलीटर",
            image: prod1Img,
          },
          {
            id: 2,
            name: "ELECTRO POWER",
            scientificName:"AZOXYSTROBIN 2.5% + THIOPHANATE METHYL 11.25% + THIAMETHOXAM 25% FS",
            category: "Fungicides",
            description:
              "ELECTRO POWER एक कीटनाशक और फफूंदनाशक का संयोजन है, जिसका उपयोग सोयाबीन फसल में बीज उपचार के रूप में किया जाता है। यह फ्यूजेरियम रूट रॉट, राइजोक्टोनिया सीडलिंग ब्लाइट और पायथियम सीडलिंग ब्लाइट जैसी बीमारियों के साथ-साथ शूट फ्लाई, सफेद गृभ और दीमक जैसे कीटों को प्रभावी रूप से नियंत्रित करता है।",
            dosage: "200 मिलीलीटर / क्विंटल बीज उपचार",
            Packaging: "1 लीटर, 400 मिलीलीटर, 200 मिलीलीटर",
            image: prod2Img,
          },
          {
            id: 3,
            name: "SUPER TARA",
            scientificName:"THIAMETHOXAM 25% WG",
            category: "कीटनाशक/रासायनिक",
            description:
              "यह एक बहुउपयोगी अंतप्रवाही कीटनाशक है जो तीव्र उदरीय तथा सस्पर्शी क्रियाशीलता रखता है, यह विभिन्न कीटों से पौधों की सुरक्षा करता है। इसका उपयोग सभी प्रकार की फसलों जैसे धान, कपास, गेहूँ, सरसों, आम, नीम्बू, टमाटर, चाय, आलू एवं अन्य सब्जियों में तना छेदक, माहू, तेला, सफेद मक्खी, चुरदा, हरा टिड्डा, सिल्ला, मच्छर आदि पर प्रभावकारी है।",
            dosage: "20 ग्राम प्रति पंप",
            Packaging: "100 ग्राम, 250 ग्राम, 500 ग्राम",
            image: prod3Img,
          },
          {
            id: 4,
            name: "CLEAR",
            scientificName:"CARBENDAZIM 12% MANCOZEB 83% WP",
            category: "Fungicides",
            description:
              "CLEAR एक घुलनशील पाउडर है जो एक अत्यधिक प्रभावी सुरक्षात्मक और फफूंदनाशी एजेंट के रूप में कार्य करता है। यह फफूंद संक्रमण के खिलाफ दीर्घकालिक सुरक्षा प्रदान करता है और बीज उपचार के लिए भी उपयुक्त है।",
            dosage: "250-300 ग्राम प्रति एकड़",
            Packaging: "100 ग्राम, 250 ग्राम, 500 ग्राम, 1 किलो",
            image: prod4Img,
          },
          // {
          //   id: 5,
          //   name: "GLO POUSHAK",
          //   scientificName:"ACTIVE CONSTITUENTS CYTOKINING & ENZYME",
          //   category: "Plant Growth Promoter",
          //   description:
          //     "GLO POUSHAK एक अत्यधिक प्रभावी पौध वृद्धि नियामक है। इसमें सक्रिय घटक के रूप में गिबरेलिक एसिड 0.001% होता है। यह पौधे की चयापचय क्रियाओं के साथ एक सहक्रियात्मक तत्व के रूप में कार्य करता है, जिससे समग्र पौध वृद्धि को बढ़ावा मिलता है। यह एंजाइमी गतिविधि को बढ़ाता है और पौधे की आंतरिक चयापचय प्रक्रियाओं को उत्तेजित करता है, जिससे फसल की गुणवत्ता और उपज में वृद्धि होती है।",
          //   dosage: "180 से 250 मिलीलीटर प्रति एकड़",
          //   Packaging: "500 मिलीलीटर, 1 लीटर",
          //   image: prod5Img,
          // },
          {
            id: 6,
            name: "SPARK",
            scientificName:"Plant Growth Regulators",
            category: "Plant Growth Promoter",
            description:
              "SPARK एक अत्यधिक प्रभावी पौध वृद्धि नियामक है जो जड़ विकास को प्रोत्साहित करता है, पौधों की प्रारंभिक वृद्धि को बढ़ाता है और फूलों को बढ़ावा देता है। यह फल और फूल गिरने को कम करता है, शाखाओं की संख्या बढ़ाता है, अंकुरण को तेज करता है और फसल की उपज को उल्लेखनीय रूप से बढ़ाता है। यह पौधों की संवेदनशील शक्ति को भी बढ़ाता है।",
            dosage: "180 से 250 मिलीलीटर प्रति एकड़",
            Packaging: "500 मिलीलीटर, 1 लीटर",
            image: prod6Img,
          },
          {
            id: 7,
            name: "DOMIS",
            scientificName:"SODIUM ACIFLUORFEN 16.5% + CLODINA PROPARGYL 8%EC",
            category: "Herbicides",
            description:
              "DOMIS एक चयनात्मक इमल्सीफिएबल कंसंट्रेट हर्बीसाइड है जिसका उपयोग सोयाबीन फसल में घास और चौड़ी पत्ती वाले खरपतवारों के नियंत्रण के लिए किया जाता है। यह स्वस्थ फसल वृद्धि को समर्थन देने के लिए प्रभावी खरपतवार प्रबंधन प्रदान करता है।",
            dosage: "400 मिलीलीटर प्रति एकड़",
            Packaging: "200 मिलीलीटर, 400 मिलीलीटर, 1 लीटर",
            image: prod7Img,
          },
          {
            id: 9,
            name: "DAMAGE",
            scientificName:"DELTAMETHRIN 11% EC",
            category: "Insecticides/Pesticides",
            description:
              "DAMAGE एक अत्यधिक प्रभावी कीटनाशक है जिसका उपयोग अमेरिकी सूँडी, धब्बेदार सूँडी, गुलाबी सूँडी, स्पोडोप्टेरा लिटुरा और रस चूसने वाले कीटों जैसे एफिड्स, जैसिड्स और सफेद मक्खियों के नियंत्रण के लिए किया जाता है। इसे सबसे कुशल और श्रेष्ठ सिंथेटिक पायरेथ्रॉइड्स में से एक माना जाता है। यह अमेरिकी सूँडी के लार्वा, फलों के बोरर्स, तने के बोरर्स और तने की मक्खियों को प्रभावी ढंग से नियंत्रित करता है जो कपास, धान, ज्वार, गन्ना, सोयाबीन और सब्जियों जैसी फसलों को नुकसान पहुँचाते हैं। DAMAGE कीटों को संपर्क के माध्यम से मारता है, जिससे तुरंत और लंबे समय तक सुरक्षा मिलती है।",
            dosage: "80 से 100 मिलीलीटर प्रति पंप",
            Packaging: "1 लीटर, 500 मिलीलीटर",
            image: prod9Img,
          },
          {
            id: 10,
            name: "MAPROTAP",
            scientificName:"CARTAP HYDROCHLORIDE 50% SP",
            category: "Insecticides/Pesticides",
            description:
              "एक कीटनाशक है जिसमें सक्रिय घटक के रूप में कार्टेप हाइड्रोक्लोराइड होता है। इसका उपयोग फसलों में विभिन्न प्रकार के कीटों को नियंत्रित करने के लिए किया जाता है जो कीटों के तंत्रिका तंत्र को बाधित करता है। यह एंजाइम एसिटाइलकोलिनेस्टरेज़ को अवरुद्ध करता है, जिसके परिणामस्वरूप पक्षाघात होता है और अंततः कीड़ों और कीटों की मृत्यु हो जाती है",
            dosage: "20 ग्राम प्रति पंप, 400 ग्राम प्रति एकड़",
            Packaging: "250 ग्राम, 500 ग्राम",
            image: prod10Img,
          },
          {
            id: 12,
            name: "KIR-TAP",
            scientificName:"CARTAP HYDROCHLORIDE 4% GR",
            category: "Insecticides/Pesticides",
            description:
              "एक कीटनाशक है जिसका उपयोग चावल और गन्ने के खेतों में कीटों को नियंत्रित करने के लिए किया जाता है। यह कम विषाक्तता, कम अवशेष वाला कीटनाशक है जो पर्यावरण के लिए सुरक्षित है। कार्टेप हाइड्रोक्लोराइड 4% जीआर संपर्क, अंतर्ग्रहण और पौधे के माध्यम से व्यवस्थित रूप से काम करता है यह चबाने और चूसने वालो कीटों को निष्क्रिय कर देता है। यह कीड़ों की सभी अवस्थाओं (अंडा, लार्वा, वयस्क) को नियंत्रित करता है।",
            dosage: "4 किलो प्रति एकड़",
            Packaging: "4 किलो बैग",
            image: prod12Img,
          },
          // {
          //   id: 13,
          //   name: "एटम सीटीपीआर (ATTOM CTPR)",
          //   category: "Insecticides/Pesticides",
          //   description:
          //     "एटम सीटीपीआर एक फफूंदनाशक संयोजन है जो धान की फसल में लीफ ब्लास्ट, शीथ ब्लाइट और ब्राउन स्पॉट जैसी बीमारियों को नियंत्रित करने के लिए उपयोग किया जाता है।",
          //   dosage: "20 ग्राम प्रति पंप",
          //   Packaging: "115 मिलीलीटर, 230 मिलीलीटर",
          //   image: prod13Img,
          // },
          {
            id: 14,
            name: "LOCKER",
            scientificName:"IMAZETHAPYR 10% SL",
            category: "Herbicides",
            description:
              "लॉकर : एक बहुआयामी एवं चयनात्मक खरपतवारनाशी है यह पौधों की पत्तियों एवं जड़ो के द्वारा अवशोषित होकर सम्पूर्ण पौधे में स्थानान्तरित हो जाता है। यह सोयाबीन एवं मूंगफली फसल में घांस कुल के एवं चौड़ी पत्ती वाले खरपतवारों पर प्रभावी नियंत्रण देता है इसका उपयोग अंकुरण के बाद किया जाता है जब खरपतवार 2-4 पत्ती अवस्था या फसल की 7-21 दिन की अवस्था में प्रयोग करें।",
            dosage: "300 एम.एल. प्रति",
            Packaging: "250ml",
            image: prod68Img,
          },
          {
            id: 15,
            name: "COR-EX",
            scientificName:"Chlorantraniliprole 18.5% W/W SC",
            category: "Insecticides/Pesticides",
            description: `यह एक अनूठे किस्म का एवजी ऐन्ध्रानिलामाइड कीटनाशक है। यह एक बहुआयामी असर वाला कीटनाशक है, जिसे धान, पत्तागोभी, कपास, गन्ना, टमाटर, मिर्च, सोयाबीन, बैंगन, अरहर, चना, उड़द, करेला, भिण्डी, मक्का, मूंग और मूंगफली पर लगने वाले विभिन्न कीटों की रोकथाम के लिए इस्तेमाल किया जाता है।`,
            dosage: "50 एम.एल प्रति एकड",
            Packaging: "60ml, 150ml, 300ml",
            image: prod15Img,
          },
          {
            id: 16,
            name: "GLO POUSHAK",
            scientificName:"Gibberellic Acid 0.001% L",
            category: "Plant Growth Promoter",
            description:
              "GLO POUSHAK एक अत्यधिक प्रभावी पौध वृद्धि नियामक है। इसमें सक्रिय घटक के रूप में गिबरेलिक एसिड 0.001% होता है। यह पौधे की चयापचय क्रियाओं के साथ एक सहक्रियात्मक तत्व के रूप में कार्य करता है, जिससे समग्र पौध वृद्धि को बढ़ावा मिलता है। यह एंजाइमी गतिविधि को बढ़ाता है और पौधे की आंतरिक चयापचय प्रक्रियाओं को उत्तेजित करता है, जिससे फसल की गुणवत्ता और उपज में वृद्धि होती है।",
            dosage: "180 से 250 मिलीलीटर प्रति एकड़",
            Packaging: "500 मिलीलीटर, 1 लीटर",
            image: GLOPOUSHAK,
          },
          {
            id: 17,
            name: "KINGA-CHINGA",
            scientificName:"SULPHUR 65% + TEBUCONAZOLE 10% WG",
            category: "Fungicides",
            description: `यह पाउडर फफूंदी, मिर्च के फल सड़न रोग और पत्ती धब्बे, सोयाबीन की फली झुलसा रोग को नियंत्रित करता है। स्टेरॉयड डॉ मेथिलेशान (एगों स्टेरोल बायोसिंथेसिस) को रोकता है`,
            dosage: "300 से 350 ग्राम प्रति एकड़",
            Packaging: "100gm, 250gm, 500gm. एवं 1kg",
            image: prod17Img,
          },
          {
            id: 18,
            name: "PENDAMAX-32",
            category: "Herbicides",
            scientificName:"PENDIMETHALIN 30% + IMAZETHAPYR 2% EC",
            description: `यह फलस उगने के बाद उपयोग होने वाला प्रभावी खरपतवारनाशक है जो सल्फो नाईल यूरिया खरपतवारनाशक परिवार का रसायन है। मेटसल्फयूरोन मिथाइल मुख्यतः चोडी पत्तो वाले खरपतवारों के नियंत्रण करने में गेहूं, रोपित धान एंव गन्ना की फसल में प्रयोग होता है।`,
            dosage: " 8 ग्राम प्रति एकड़",
            Packaging: "8 ग्राम",
            image: PENDAMAX32,
          },
          {
            id: 19,
            name: "GLO-GRIP",
            scientificName:"Metsulfuron Methyl 20% WP",
            category: "Herbicides",
            description: `यह फलस उगने के बाद उपयोग होने वाला प्रभावी खरपतवारनाशक है जो सल्फो नाईल यूरिया खरपतवारनाशक परिवार का रसायन है। मेटसल्फयूरोन मिथाइल मुख्यतः चोडी पत्तो वाले खरपतवारों के नियंत्रण करने में गेहूं, रोपित धान एंव गन्ना की फसल में प्रयोग होता है।`,
            dosage: "8 grams per acre",
            Packaging: "8grams",
            image: prod19Img,
          },
          {
            id: 20,
            name: "GLOQUAT",
            scientificName:"PARAQUAT DICHLORIDE 24% SL",
            category: "Herbicides",
            description: `सभी स्पष्ट व्यापक स्पेक्ट्रम, गैर चयनात्मक और संपर्क Herbicide 24% पैराक्वाट डाइक्लोराइड एआई युक्त है जो प्रभावी रूप से व्यापक मातम और घास को नियंत्रित करता है

यह पोस्ट उद्भव निर्देशित आवेदन और कई फसलों में पूर्व संयंत्र आवेदन के रूप में प्रयोग किया जाता है यह सुपरऑक्साइड का उत्पादन करके प्रकाश संश्लेषण के दौरान सेल झिल्ली और साइटोप्लाज्म को नुकसान पहुंचाता है`,
            dosage: "750 से 1000 एम.एल. प्रति एकड़",
            Packaging: "500ml, 1 Ltr.",
            image: GLOQUAT,
          },
          {
            id: 21,
            name: "SUPLEX",
            scientificName:"SULPHUR 80% WDG",
            category: "Fungicides",
            description: `
यह एक सम्पर्क फफूंदनाशक है जिसमे सल्फर 80 भार/भार व अन्य सहयक तत्व मौजूद है सुपलेक्स के छोटे छोटे दाने अतिशीघ्र मिट्टी के अन्दर पानी के साथ साथ घुल जाते है जिससे यह पूरे खेत में फैल जाता है यह फसल में चूर्णी आसिता व पामा की रोकथाम करता है।`,
            dosage: "5 से 10 किलो प्रति एकड़",
            Packaging: "3 kg",
            image: prod21Img,
          },
          {
            id: 22,
            name: "ZUZO/AKIRA",
            scientificName:"Chlorantraniliprole 9.3% + Lambdacyhalothrin 4.6% ZC",
            category: "Insecticides/Pesticides",
            description: `
यह ऐसे रसायन है जिनका उपयोग कीटनाशकों में कई प्रकार के कीटों को मारने के लिए एक साथ किया जाता है। वे व्यापक स्पेक्ट्रम वाले पत्तेदार कीटनाशक है जिनका उपयोग कपास, सोयाबीन, मूंग, धान और बैंगन जैसी फसलों पर किया जा सकता है।

क्लोरेंट्रानिलिप्रोल एक प्रणालीगत कोटनाशक जो पौधों द्वारा अवशोषित किया जाता है और उन कीटों को मारता है जो उन्हें खाते है। यह फीट की मांसपेशियों के कार्य को बाधित करता है,जिससे पक्षाघात और मृत्यु हो जाती है। लैम्ब्डा-साइहेलोथिन एक संपर्क कीटनाशक जो संपर्क में आने पर कीटों को मार देता है। यह कीट के तंत्रिका तंत्र को वाधित करता है, जिससे पक्षाघात और मृत्यु हो जाती है।`,
            dosage: "5 से 10 किलो प्रति एकड़",
            Packaging: "100ml 250ml 500ml",
            image: prod22Img,
          },
//           {
//             id: 23,
//             name: "CYPER STAR",
//             category: "Insecticides/Pesticides",
//             description: `सायपरमेथरिन 10% EC

// यह सिंथेटिक पाइराथ्राइड ग्रुप का कीटनाशक है। यह अमेरिकन डोडे की सुण्डी, फल छेदक, तना छेदक तथा तने की मक्खी को प्रभावी रुप से नियंत्रित करता है यह सम्पर्क में आते ही किटों को मार देता है।

// यह कीटों की रोकथाम के लिये सोयाबीन, धान, कपास, चना व सब्जीयों पर इस्तेमाल किया जाता है।`,
//             dosage: "40-50 एम. एल. प्रति पम्प",
//             Packaging: "1 Ltr, 500 ml",
//             image: prod23Img,
//           },
          {
            id: 24,
            name: "SHINE",
            scientificName:"LAMBDACYHALOTHRIN 5% EC",
            category: "Insecticides/Pesticides",
            description: `लेम्डासायहेलोथ्रिन 5% EC

यह एक सिंथेटिक पायराथ्राइड समूह का कीटनाशी है, यह कीटों की विस्तृत श्रृंखला को नियंत्रण करने में उपयोग होता है, साथ ही कुछ हद तक यह माहु को भी नियंत्रित करने में उपयोगी साबित हुआ है, यह एफिड, कोलोराडो बोटल, लार्वा, तिलचट्टों, एवं मच्छरों मक्खियों को भी नियंत्रित करने में कारगर साबित हुआ है इसका उपयोग सभी प्रकार की फसलों जैसे, सोयाबीन, कपास, धान, एवं सभी प्रकार की सब्जियों पर प्रभावकारी है। सोयाबीन, गेहुँ, चना, मुंग, उडद, उरहर, चावल, प्जाय, लहसन, अदरक, टमाटर, मिर्च, कपास, आलू आदि।`,
            dosage: "35 to 40 ml per pump",
            Packaging: "1 Ltr, 500 ml",
            image: prod24Img,
          },
          {
            id: 25,
            name: "TAKITO",
            scientificName:"QUIZALOFOP-ETHYL 10% EC",
            category: "Herbicides",
            description: `यह एक क्विज़ालोफोप-इथाइल 10 प्रतिशत ई.सी. है यह चयनात्मक, निर्गमनोत्तर खरपातवार नाशक है जो मूंग, उड़द और सोयाबीन की फसलों में घांस समूह के खरपतवारों के नियंत्रण के लिए प्रभावशाली है यह सकरी पत्ती वाले चारे पर कार्य करता है।`,
            dosage: "25 से 30 एम.एल. प्रति पम्प",
            Packaging: "100ml, 250ml, 500ml, 1 Ltr.",
            image: prod70Img,
          },
          {
            id: 26,
            name: "KITO",
            scientificName:"BIO PRODUCT",
            category: "Insecticides/Pesticides",
            description: `किटों एक अनूठें किस्म का प्राकृतिक एवं जैविक पर बना हुआ तरल द्रव्य है। यह एक बहुआयामी असरकारक बॉयो पेस्टीसाइड उत्पाद है। इसका उपयोग विभिन्न फसलो पर लगने वाली सूंडियो एवं विभिन्न कीटों की रोकथाम के लिए किया जा सकता है।

उपयोग- किटों का उपयोग मूंग, सोयाबीन, कपास, धान, टमाटर, चना, मक्का, पत्तागोभी, बैगन, मूंगफली, तुअर इत्यादि फसलों में लगने वाले कुतरने व चूसने वाले कीड़ों एवं सुंडीयों के लिए उत्पन्त उपयोगी है। सह पर्यावरण एवं पशुओं के लिए सुरक्षित है इसका कोई नकारात्मक प्रभव नहीं है।

प्रयोग का समय व तरीका किटो का उपयोग फसल की बुआई के 15 से 20 दिन के बाद किया जा सकता है। बाद में आवश्यकता अस्सर इसका उपयोग करना चाहिए तथा छिड़काव के समय पौधा पूर्णरूप से भौगना चाहिए।

मात्रा: 10 एम.एल प्रति 15 लीटर पानी में

छिड़काव करना चाहिए।`,
            dosage: "10 ml per 15 liters of water",
            Packaging: "50 ml, 100 ml, 250 ml",
            image: prod26Img,
          },
          {
            id: 27,
            name: "WEED WAAR",
            scientificName:"CLODINAFOP PROPARGYL 15% WP",
            category: "Herbicides",
            description: `क्लोडिनोफोप प्रोपरजिल 15% WP सक्रिय घटक क्लोडिनाफोप-प्रोपरजिल और सफनर क्लोक्रिटीकेट-मैक्सिल पत्तियों के माध्यम से अवशोषित होते हैं और सक्रिय रूप से बढ़ते पौधों की नियंत्रण प्रदान करता है। उन्हें पौधों में तेजी से स्थानांतरित किया जाता है और मेरिस्टेमैटिक ऊतकों में जमा होता है। प्राप्त परिणाम एंजाइम एमिटिल कोए कार्बोक्साइल (एसीसी-एएसई) का अवरोध है। आवेदन के 48 घंटे के भीतर, अतिसंवेदनशील घास प्रजातियां बढ़ने लगीं।
पौधे की मृत्यु 2-3 सप्ताह के भीतर होती है। उत्पाद के समय के लिए उत्पादक को अधिक लचीलापन प्रदान करती है। फसल रोटेशन के लिए सुरक्षा की कोई सीमा नहीं है और इसलिए अनुवर्ती फसलों के लिए अधिक लचीलापन प्रदान करता है। सुरक्षा में एक उत्कृष्ट पर्यावरण प्रोफ़ाइल है और एक एकीकृत फसल प्रबंधन कार्यक्रम में बहुत अच्छी तरह से फिट बैठता है। मिट्टी में इसकी आधा जीवन अवधि केवल कुछ ही दिन है. और लीचिंग की संभावना बहुत कम है। यहां उत्पाद प्रस्ताव 160 ग्राम पैक है, जो आपके पते पर पहुंचाया गया है। केवल कृषि प्रयोजन के लिए उपयोग करें`,
            dosage: "160 grams per acre",
            Packaging: "160 gm",
            image: prod27Img,
          },
          {
            id: 28,
            name: "GLYDER",
            scientificName:"GLYPHOSATE 41% SL",
            category: "Herbicides",
            description: `यह एक बहुउपयोगी (प्रीइमरजेन्ट) खरपतवार नाशक है यह सभी प्रकार के खरपतवारों को नियंत्रित करता है यह जड़ो में पहुँचकर समूल नियंत्रित करता है।`,
            dosage: "800-1200 ml per acre",
            Packaging: "1 Ltr.",
            image: GLYDER,
          },
          {
            id: 30,
            name: "G-MIDA SUPER",
            scientificName:"IMIDACLOPRID 30.5% SC",
            category: "Insecticides/Pesticides",
            description: `यह एक अन्तरप्रवाही कीटनाशक है जिसका प्रयोग इमारतों में दीमक की रोकथाम के लिए इमारत के निर्माण से पहले और बाद में किया जाता है इसका उपयोग कपास में आने वाले चूसक किटों जैसे माहु, तेला, चुरदा तथा धान में आनेवाले भूरे पीत और सफेद पीठ के फुको की रोकथाम के लिए किया जाता है।`,
            dosage: "10 ml per pump",
            Packaging: "100 ml, 250 ml",
            image: prod30Img,
          },
          {
            id: 31,
            name: "PROTON",
            scientificName:"PROFENOFOS 50% EC",
            category: "Insecticides/Pesticides",
            description: `
यह एक तीव्र असर कारक कीटनशाक है। यह कीटों के स्पर्श में आने एवं पेट में जाने पर असर करता है। यह इल्लियों के अण्डे को अन्दर ही खत्म कर देता है।

इसका उपयोग फसल कपास, चना, तुअर, सोयाबीन, मटर, मूंग एवं सभी प्रकार की सब्जियाँ आदि फसलों पर किया जा सकता है।

कीट: तेला, माह, सफेद मक्खी, इल्ली, हरी व काली इल्ली, फल छेदक आदि पर असर करता है । `,
            dosage: "300-400 ml per acre",
            Packaging: "100 ml, 250 ml, 500 ml, 1 Ltr",
            image: prod31Img,
          },
          {
            id: 33,
            name: "VAID RAJ",
            scientificName:"HUMIC ACID 100% WATER SOLUBLE",
            category: "Plant Growth Promoter",
            description: `इसके प्रयोग से जर्मिनेशन (अंकुरण क्षमता) ज्यादा होता है, जड़े अधिक सुगठित और पूर्ण विकास लिये होती है जो कि बुनियादी तौर पर बहुत जरुरी है, उत्तम जड़े विकसित पौधा सीड ट्रीटमेंट के बाद बीजों का त्वरित विकास होता है, इससे उपचारित बीज मौसम की मार के प्रति ज्यादा सहनशील होते है।

अति वर्षा और अल्प वर्षा दोनों में ही विकास अवरुद्ध नहीं होता, इससे उपचारित फसलें असमान्य नहीं होती है पूर्ण संतुलित फसलें, बेहतर उपज वृद्धि, एक समान गुणवत्ता और 30-40% उपज वृद्धि होती ही है।`,
            dosage: "10 to 15 grams per pump.",
            Packaging: "100 gm, 250 gm, 500 gm.",
            image: prod33Img,
          },
          {
            id: 34,
            name: "CARGO ZYME",
            scientificName:"PLANT ORGANIC ACTIVATOR",
            category: "Plant Growth Promoter",
            description: `
इसका उपयोग सभी प्रकार की फसलों में किया जाता है। यह फसल की पैदावार में सुधार लाता है। अंकुरण की गति तेज करता है। एन्जाइम प्रणाली को प्रभावित करता है। फसल को जल्दी पकाता है।`,
            dosage: "5 to 10 kg per acre",
            Packaging: "10 kg bucket and 5 kg bag",
            image: prod34Img,
          },
          {
            id: 35,
            name: "DOLPHIN",
            scientificName:"IMPOTED Zinc Sulphate Monohydrate 33%",
            category: "Plant Growth Promoter",
            description: `जिंक सल्फेट मोनोहाइड्रेट (Zn 33%, S-15%) का इस्तेमाल फसलों में जिंक की कमी को दूर करने के लिए किया जाता है। इसका इस्तेमाल उर्वरक के रूप में किया जाता है। यह पौधों के विकास हार्मोन के संश्लेषण में वृद्धि करता है। यह नाइट्रोजन और फॉस्फोरस के इस्तेमाल को बढ़ाता है। यह मिट्टी में पीएच स्तर को नियंत्रित करता है। यह पत्तियों को प्रारंभिक अवस्था में हरा रंग देने में मदद करता है और फलों की पैदावार बढ़ाता है। यह जल धारण क्षमता में वृद्धि करता है।`,
            dosage: "5 kg per acre",
            Packaging: "5 kg",
            image: prod35Img,
          },
          {
            id: 36,
            name: "GLOZYME",
            scientificName:"PLANT ORGANIC ACTIVATOR",
            category: "Plant Growth Promoter",
            description: `मिट्टी को डीटॉक्सिफ़ाई और कायाकल्प करता है। फायदेमंद माइक्रोबियल विकास की सुविधा प्रदान करता है।  प्रफ्यूज, तेजी से और व्यापक रूट विकास में मदद करता है, और पौधों की उत्पादकता में सुधार करता हैबीमारी और कीटों और जलवायु तनाव के खिलाफ पौधों के प्राकृतिक प्रतिरोध को प्रोत्साहित करता है ।पर्यावरण के अनुकूल क्योंकि यह ऑर्गेनिक है।`,
            dosage: "5 to 10 kg per acre",
            Packaging: "10 kg bucket and 5 kg bag",
            image: prod36Img,
          },
          {
            id: 37,
            name: "TWINS-404",
            scientificName:"PROFENOFOS 40% + CYPERMETHRIN 4% E.C.",
            category: "Insecticides/Pesticides",
            description: `इसका उपयोग कपास की सुंडियों तथा चना, सोयाबीन और सब्जियों में इल्लियों व अंडो की रोकथाम के लिए किया जाता है। यह एक उदर एवं संपर्क बहुउपयोगी कीटनाशक है जो कपास के टिंडो की सुंडियों जैसे अमरीकन सुंडी, चित्तीदार सुंडी, सफेद मक्खी और धान के तना छेदक, पत्ता लपेट सुंडी, हरे फुदके और हिस्पा जैसे हानिकारक कीटों को लंबे समय तक नियंत्रित करता है। इसके प्रयोग से मिर्च व सब्जियों पर होने वाले कीटों की भी रोकथाम होती है।`,
            dosage: "50 एम.एल. प्रति पम्प",
            Packaging: "250, 500 ml एवं 1 Ltr.",
            image: prod37Img,
          },
          {
            id: 38,
            name: "AKIRA",
            scientificName:"Chlorantraniliprole 9.3% + Lambdacyhalothrin 4.6% ZC",
            category: "Insecticides/Pesticides",
            description: `यह ऐसे रसायन है जिनका उपयोग कीटनाशकों में कई प्रकार के कीटों को मारने के लिए एक साथ किया जाता है। वे व्यापक स्पेक्ट्रम वाले पत्तेदार कीटनाशक है जिनका उपयोग कपास, सोयाबीन, मूंग, धान और बैंगन जैसी फसलों पर किया जा सकता है।

क्लोरेंट्रानिलिप्रोल एक प्रणालीगत कोटनाशक जो पौधों द्वारा अवशोषित किया जाता है और उन कीटों को मारता है जो उन्हें खाते है। यह फीट की मांसपेशियों के कार्य को बाधित करता है,जिससे पक्षाघात और मृत्यु हो जाती है। लैम्ब्डा-साइहेलोथिन एक संपर्क कीटनाशक जो संपर्क में आने पर कीटों को मार देता है। यह कीट के तंत्रिका तंत्र को वाधित करता है, जिससे पक्षाघात और मृत्यु हो जाती है।`,
            dosage: "80 से 100 एम. एल. प्रति एकड़",
            Packaging: "100ml 250ml 500ml",
            image: Akira,
          },
          {
            id: 39,
            name: "G-MIDA",
            scientificName:"IMIDACLOPRID 17.8% SL",
            category: "Insecticides/Pesticides",
            description: `यह एक अन्तरप्रवाही कीटनाशक है जिसका प्रयोग इमारतों में दीमक की रोकथाम के लिए इमारत के निर्माण से पहले और बाद में किया जाता है इसका उपयोग कपास जैसे फसलों में आने वाले रस चूसक कीटों तथा धान में आने वाले फुदको, माहु तेला, चेपा आदि की रोकथाम के लिये भी किया जाता है।`,
            dosage: "15 से 20 एम.एल. प्रति पम्प",
            Packaging: "100ml, 250ml",
            image: prod39Img,
          },
          {
            id: 40,
            name: "HUNTER",
            scientificName:"DELTAMETHRIN 2.8% EC",
            category: "Insecticides/Pesticides",
            description: `इसका इस्तेमाल अमेरिकन सुण्डी, चित्तीदार सुण्डी, गुलाबी सुण्डी, स्पोडोपटेरा लिट्युरा तथा रस चुसक कीटों जैसे तेला, चुरदा तथा सफेद मक्खी को प्रभावी रुप से नियत्रंण करने के लिए किया जाता है। संश्लेषित पायराध्राइड में सबसे ज्यादा प्रभावी व बेहतर है। यह अमेरिकन डोडे की सुण्डी, फल छेदक, तना छेदक तथा तने की मक्खी को प्रभावी रुप से नियंत्रित करता है। जो कपास, धान, ज्वार, गन्ना, सोयाबीन, तथा सब्जियों को नुकसान पहुँचाते हैं। यह सम्पर्क में आते ही कीटों को मार डालता है।`,
            dosage: "40 एम. एल प्रति पम्प",
            Packaging: " 1 Ltr. 500ml",
            image: prod40Img,
          },
          {
            id: 41,
            name: "CYPER STAR",
            scientificName:"CYPERMETHRIN 10% EC",
            category: "Insecticides/Pesticides",
            description: `यह सिंथेटिक पाइराथ्राइड ग्रुप का कीटनाशक है। यह अमेरिकन डोडे की सुण्डी, फल छेदक, तना छेदक तथा तने की मक्खी को प्रभावी रुप से नियंत्रित करता है यह सम्पर्क में आते ही किटों को मार देता है।

यह कीटों की रोकथाम के लिये सोयाबीन, धान, कपास, चना व सब्जीयों पर इस्तेमाल किया जाता है।`,
            dosage: "40-50 एम. एल. प्रति पम्प",
            Packaging: "1 Ltr. 500ml",
            image: prod41Img,
          },
          {
            id: 42,
            name: "FIFO",
            scientificName:"BIO PRODUCT",
            category: "Insecticides/Pesticides",
            description: `फीफो एक किस्म का प्राकृतिक एवं जैविक, तरल द्रव्य है। यह एक बहुआयामी असरकारक बॉयो पेस्टीसाइड उत्पाद है। इसका उपयोग विभिन्न फसलो पर लगने वाली सूंडियो एवं विभिन्न कीटों की रोकथाम के लिए किया जा सकता है।`,
            dosage: "10 एम.एल प्रति 15 लीटर पानी में छिड़काव करना चाहिए।",
            Packaging: "50ml, 100ml 250ml",
            image: prod42Img,
          },
          {
            id: 43,
            name: "VIBER",
            scientificName:"DIAFENTHIURON 47.8% SC",
            category: "Insecticides/Pesticides",
            description: `यह एक अनूठे किस्म का एवजी ऐन्थ्रानिलामाइड कीटनाशक है। यह एक बहुआयामी असर वाला कीटनाशक है, जिसे धान, पत्तागोभी, कपास, गन्ना, टमाटर, मिर्च, सोयाबीन, वैगन, अरहर, चना, उड़द, करेला, भिण्डी, मक्का, मूंग और मूंगफली पर लगने वाले विभिन्न कीटों की रोकथाम के लिए इस्तेमाल की सिफारिश की जाती है।`,
            dosage: "50 एम.एल प्रति एकड",
            Packaging: "100ml, 250ml",
            image: prod43Img,
          },
          {
            id: 44,
            name: "QUIZ SUPER",
            scientificName:"QUIZALOFOP-ETHYL 5% EC",
            category: "Herbicides",
            description: `एक शाकनाशी है जिसका उपयोग सोयाबीन, कपास और मूंगफली जैसी फसलों में घास के खरपतवारों को नियंत्रित करने के लिए किया जाता है। यह उभरने के बाद का एक चयनात्मक शाकनाशी है जो पत्तियों द्वारा अवशोषित हो जाता है और पूरे पौधे में स्थानांतरित हो जाता है। क्विज़ालोफ़ॉप-एथिल 5% ईसी एंजाइम एसिटाइल-सीओए कार्बोक्सिले.ज़ (एसीसीज़) को रोकता है, जो पौधों में लिपिड संश्लेषण के लिए आवश्यक है। इससे खरपतवारों में कोशिका झिल्ली का निर्माण बाधित हो जाता है यह खरपतवारों को बिना जलाए ही मार देता है, ताकि वे दोबारा न उग सके`,
            dosage: "25 से 30 एम.एल. प्रति पम्प",
            Packaging: "250ml, 500ml, 1Ltr.",
            image: prod44Img,
          },
          {
            id: 45,
            name: "TEMBO-G",
            scientificName:"TEMBOTRIONE 34.4% W/W SC",
            category: "Herbicides",
            description: `एक व्यापक स्पेक्ट्रम वाला पोस्ट-इमर्जेंस हर्बिसाइड है, जिसे मक्का में घास और चौड़ी पत्ती वाले खरपतवारों को दबाने के लिए एक सफेक्टेंट के साथ संयोजन में उपयोग करने की सलाह दी जाती है: टेम्बोट्रिऑन जो टैम्बो- जी में सक्रिय घटक है।`,
            dosage: "115 एम.एल. प्रति एकड़",
            Packaging: "115 ml., 230 ml.",
            image: TEMBOG,
          },
          {
            id: 46,
            name: "ALTERNATE",
            scientificName:"ATRAZINE 50% W.P",
            category: "Herbicides",
            description: `एट्राजिन हर्बिसाइड घास और चौड़ी पत्ती वाले खरपतवारों के नियंत्रण के लिए एक चयनात्मक व्यापक स्पेक्ट्रम हर्बिसाइड है।

यह पूर्व और लक्षित पश्च उद्भव अनुप्रयोगों दोनों के लिए है जो ट्राइएज़ीन समूह से संबंधित हैं।

मक्का और गन्ने पर पूर्व-उदय के रूप में प्रभावी है और मक्का की फसल पर रोपाई के तुरंत बाद भी इसका प्रयोग किया जा सकता है।

यह एक प्रणालीगत शाकनाशी है जो जड़ों और पत्तियों के माध्यम से अवशोषित होता है।`,
            dosage: "500 ग्राम प्रति एकड़",
            Packaging: "500gm",
            image: prod46Img,
          },
          {
            id: 47,
            name: "BENZIRO",
            scientificName:"Thiamethoxam 30% FS",
            category: "Fungicides",
            description: `यह एक बहुउपयोगी फफूंदनाशी है जो बीज उपचार करने से फसल के आरंभ में आने वाले चूषक कीटों को नियंत्रित करती है। इसकी आवश्यक मात्रा कपास की फसल में होने वाले कीट जैसै तेला, माहू और सफेद मक्खी ज्वार व मक्का की प्ररोह मक्खी, गेंहू के दीमक, भिंडी के तेला, धान के चुरदा, हरा पत्ती का फुदका व चक्रीय मेगोट, सूरजमुखी के तेला व चुरदा, सोयाबीन की तना मक्खी तथा मिर्च के चुरदा के नियंत्रण के लिए बीज उपचार करने के लिए उपयोग की जाती है।`,
            dosage: "400 मिली प्रति क्विंटल",
            Packaging: "100ml, 250ml, 500ml,1Ltr.",
            image: prod47Img,
          },
          {
            id: 48,
            name: "STODIA",
            scientificName:"Azoxystrobin 11% + Tebuconazole 18.3% SC",
            category: "Fungicides",
            description: `यह एक संयोजित असरदार रोगरक्षक, रोगनिवारक एवं रोगनाशक उत्पाद है। यह मिर्च के चूर्ण फफूंदी एंव फल सड़न को नियंत्रित करता है।`,
            dosage: " 240 से 300 मिली प्रति एकड़",
            Packaging: "250ml, 500ml, 1 Ltr.",
            image: prod48Img,
          },
          {
            id: 49,
            name: "TOP N TOP",
            scientificName:"Ν.Ρ.Κ.00:52:34",
            category: "Plant Growth Promoter",
            description: `पौधे को संतुलित मात्रा में फास्फोरस और पोटाश प्रदान करता है
उपयोग- इसके उपयोग से फसल में अधिक फूलों की मात्रा में बढ़ोतरी होती है तथा फुलों एवं फलों को गिरने से रोकता है।`,
            dosage: "100 ग्राम प्रति पम्प",
            Packaging: "1 किलो",
            image: prod49Img,
          },
          {
            id: 50,
            name: "TOP N TOP",
            scientificName:"Ν.Ρ.Κ. 12:61:00",
            category: "Plant Growth Promoter",
            description: `इस उर्वरक का इस्तेमाल पौधों में जडों के विकास, तने की मजबूती, और फूलों और फलों की संख्या बढाने के लिए किया जाता है। यह उर्वरक, नाइट्रोजन और फॉस्फोरस से भरपूर है। `,
            dosage: "1 किलो प्रति एकड़",
            Packaging: "1 किलो",
            image: prod50Img,
          },
          {
            id: 51,
            name: "TOP N TOP",
            scientificName:"N.P.K. 00:00:50",
            category: "Plant Growth Promoter",
            description: `उर्वरक में पोटैशियम की मात्रा ज्यादा होती है।  यह एक जल घुलनशील उर्वरक है। इसका इस्तेमाल फसलों में पोटैशियम और सल्फर की कमी को पूरा करने के लिए किया जाता है। यह उर्वरक पौधों के स्वास्थ्य में सुधार करता है और उनकी पैदावार बढाता है।  फूलों और फलों की गुणवत्ता में सुधार होता है,पौधों की रोग प्रतिरोधक क्षमता बढती है, और पौधों को सूखा सहने में मदद मिलती है।  
00:00:50 उर्वरक का इस्तेमालः अंगूर, अनार, केला, कपास, टमाटर, प्याज, गन्ना, अदरक, हल्दी, तरबूज, फूलों की खेती में किया जा सकता है.`,
            dosage: "1 किलो प्रति एकड़",
            Packaging: "1 किलो",
            image: prod51Img,
          },
          {
            id: 52,
            name: "RAFTAR PLUS",
            scientificName:"Ν.Ρ.Κ. 19:19:19",
            category: "Plant Growth Promoter",
            description: `नये युग का पुर्णतः घुलनशील आयातित एन.पी. के. उत्पाद है, जो पर्णिय छिड़काव व डिप्र एरिगेशन के लिए अत्यंत उपयोगी है। इसमें नाइट्रोजन, फास्फोरस और पोटेशियम तत्व होते हैं, जो पौधे को तुरंत उपलब्ध होते हैं। एन.पी. के. पौधे को एक समान विकास में मदद करता है बीज व फल निर्माण के समय पौधों को पोषण प्रदान करता है। क्लोरोफिल निर्माण में सहायता करता है, प्रोटीन की मात्रा बढ़ाता है।`,
            dosage: "100 ग्राम प्रति पम्प",
            Packaging: "1 किलो",
            image: prod52Img,
          },
          {
            id: 53,
            name: "RAFTAR PLUS",
            scientificName:"Ν.Ρ.Κ. 13:00:45",
            category: "Plant Growth Promoter",
            description: `एन.पी. के. 13:00: 45 को पोटैशियम नाइट्रेट कहा जाता है। यह एक पानी में घुलने वाला उर्वरक है। इसमें 13% नाइट्रोजन और 45% पोटैशियम होता है। इस उर्वरक के इस्तेमाल से कम तापमान में भी पौधों का हरापन बना रहता है। सूखे और सर्दियों के तनाव से पौधों को सुरक्षा मिलती है।पौधों के स्वास्थ्य और पैदावार में सुधार होता है।सब्ज़ियों, खेतों की फसलों, फूलों, और फलों की गुणवत्ता में सुधार होता है। यह सभी फसलों और फसल चक्र के सभी बढ़ते चरणों के लिए उपयुक्त होता है। इस उर्वरक का इस्तेमाल ड्रिप सिंचाई और पत्तों पर किया जा सकता है। यह सभी पानी में घुलनशील उर्वरकों के साथ संगत होता है।`,
            dosage: "1 किलो प्रति एकड़",
            Packaging: "1 किलो",
            image: prod53Img,
          },
          {
            id: 54,
            name: "FORCE-505",
            scientificName:"Chlorpyrifos 50% + Cypermethrin 5% E.C.",
            category: "Insecticides/Pesticides",
            description: `इसका इस्तेमाल अमेरिकन सुण्डी, चित्तीदार सुण्डी, गुलाबी सुण्डी, स्पोडोपटेरा लिट्युरा तथा रस चुसक कीट जैसे तेला, चुरदा तथा सफेद मक्खी को प्रभावी रुप से नियत्रंण करने के लिए किया जाता है। संश्लेषित पायराघ्राइड में सबसे ज्यादा प्रभावी व बेहतर है। यह अमेरिकन डोडे की सुण्डी, फल छेदक, तना छेदक तथा तने की मक्खी को प्रभावी रुप से नियंत्रित करता है, जो कपास, धान, ज्वार, गजा, सोयाबीन, तथा सब्जियों को नुकसान पहुंचाते हैं। यह सम्पर्क में आते ही कीटो को मार डालता है।`,
            dosage: "40 एम.एल. प्रति पम्प",
            Packaging: "250ml, 500ml एवं 1 Ltr.",
            image: prod54Img,
          },
          {
            id: 55,
            name: "GLO-QC",
            scientificName:"CYPERMETHRIN 3% QUINALPHOS 20% EC",
            category: "Insecticides/Pesticides",
            description: `
यह एक स्पर्शजन्य व पेट में असर करने वाला कीटनाशक है जो कपास के अमेरीकन डोडे की सून्डी, धब्बे दार डोडे की सून्डी, तेला और बैगन के तना एवं फल छेदक किटो पर बहुत असरदार है। इसका उपयोग कपास, सोयाबीन, चना, मुग, आदी फसलों पर किया जा सकता है।`,
            dosage: "30-50 एम.एल. प्रति पम्प",
            Packaging: "1 Ltr. एवं 500 ml",
            image: prod55Img,
          },
          {
            id: 56,
            name: "KAREENA",
            scientificName:"ALPHAMETHRIN 10% EC",
            category: "Insecticides/Pesticides",
            description: `यह सिंथेटिक पाइराथ्राइड ग्रुप का कीटनाशक है। यह स्पर्श एवं उदर क्रियाविधि बाला व्यापक कीटनाशी है। यह अत्यंत प्रभावी एवं त्वरित क्रियाविधि द्वारा अच्छे परिणाम देता है। यह अमेरिकन डोडे की सुण्डी, फल छेदक, तना छेदक तथा तने की मक्खी को प्रभावी रुप से नियंत्रित करता है यह सम्पर्क में आते ही कीटों को मार देता है।`,
            dosage: "30 एम. एल प्रति पम्प",
            Packaging: "1 Ltr. 500 ml",
            image: prod56Img,
          },
          {
            id: 57,
            name: "MISSION",
            scientificName:"EMAMECTIN BENZOATE 5% SG",
            category: "Insecticides/Pesticides",
            description: `मिशन यह नई पीढ़ी का जैव मिश्रण है जो कि शक्ति व गुणवत्ता को बढ़ाता है व कीटों के आक्रमण को रोकता है घुन एवं लेपिडोप्टेरा पर भी यह असरदायक है। प्रयोग करने की विधिः प्रपत्र के अनुसार छिड़‌काव द्वारा प्रयोग करना चाहिये सावधानी: बोतल खोलने के तुरंत बाद इसका प्रयोग करना चाहिये सुरक्षित शुष्क स्थान पर रखे व बच्चों की पहुँच से दूर रखें। मुँह, आँख व त्वचा के सम्पर्क से बचे छिड़‌काव करते समय सुरक्षात्मक वस्त्र पहने।`,
            dosage: "10 ग्राम प्रति पम्प",
            Packaging: "50gm 100gm. 250gm, 500gm",
            image: prod57Img,
          },
          {
            id: 58,
            name: "DABANG",
            scientificName:"EMAMECTIN BENZOATE 5% SG",
            category: "Insecticides/Pesticides",
            description: `दबंग यह नई पीढ़ी का जैव मिश्रण है जो कि शक्ति व गुणवत्ता को बढ़ाता है व कीटों के आक्रमण को रोकता है धुन एवं लेपिडोप्टेरा पर भी यह असरदायक है। प्रयोग करने की विधि : प्रपत्र के अनुसार प्रयोग करना चाहिये सावधानी : बोतल खोलने के तुरंत बाद इसका प्रयोग करना चाहिये सुरक्षित शुष्क स्थान पर रखे व बच्चों की पहुँच से दूर रखें। मुँह, आँख व त्वचा के सम्पर्क से बचे छिड़काव करते समय सुरक्षात्मक वस्त्र पहने।`,
            dosage: "10 ग्राम प्रति पम्प",
            Packaging: "50gm, 100gm, 250gm. 500gm",
            image: prod58Img,
          },
          {
            id: 59,
            name: "XTREME",
            scientificName:"LAMBDA CYHALOTHRIN 4.9% CS",
            category: "Insecticides/Pesticides",
            description: `यह एक सिंथेटिक पायराघ्राइड समूह का कीटनाशी है, यह कीटों की विस्तृत श्रखंला को नियंत्रण करने में उपयोग होता है साथ ही कुछ हद तक यह माहु को भी नियंत्रित करने में उपयोगी साबित हुआ है, यह एफिड, कोलोराडो बीटल, लार्वा, तिलचट्टों एवं मच्छर मक्खियों को भी नियंत्रित करने में कारगर साबित हुआ है इसका उपयोग सभी प्रकार की फसलों जैसे सोयाबीन, कपास, धान एवं सभी प्रकार की सब्जियों पर प्रभावकारी है।

फसलें : सोयाबीन, गेहुँ, चना, मुंग, उड़द, अरहर, चावल, प्याज, लहसुन, अदरक, टमाटर, मिर्च, कपास, आलू, आदि।`,
            dosage: "25-30 एम.एल. प्रति पम्प",
            Packaging: "1 Ltr. 500ml",
            image: prod59Img,
          },
          {
            id: 60,
            name: "WWF",
            scientificName:"FIPRONIL 40% + IMIDACLOPRID 40% WG",
            category: "Insecticides/Pesticides",
            description: `यह दो रासायनिक समूह फेनिलपायराज़ोल (फिप्रोनिल) और नियोनिकोटिनोइड (इमिडाक्लोप्रिड) का एक संयोजन उत्पाद है। कीटों के खिलाफ शिरासागी की दोहरी कार्रवाई कीट के प्रभावी नियंत्रण को सुनिश्चित करती है। गन्ना, सफेद ग्रब के मिट्टी के कीड़ों पर शिरसागी की सिफारिश की जाती है। इसे किसी भी स्तर पर मिट्टी की खाई के रूप में लगाया जा सकता है। कीड़ों का लंबा और लगातार नियंत्रण प्रदान करता है। यह मिट्टी के कणों के साथ अपनी मजबूत आत्मीयता के कारण सफेद ग्रब के बार-बार होने वाले हमले को नियंत्रित कर सकता है।`,
            dosage: "80 से 100 ग्राम प्रति एकड़ पैकिंग",
            Packaging: "40gm, 100gm",
            image: prod60Img,
          },
          {
            id: 61,
            name: "DANGER",
            scientificName:"EMAMECTIN BENZOATE 1.9% EC",
            category: "Insecticides/Pesticides",
            description: `यह उत्पाद अत्याधुनिक जैविक अनुसंधान पर आधारित बहुत अधिक प्रभावशाली कीटनाशक है। जिससे सभी फसलों पर छिड़काव के बाद अच्छे परिणाम प्राप्त हुए है। यह सभी हानिकारक कीटो जैसे सोयाबीन की इल्ली, चने की इल्ली, चितकबरी इल्ली, काली इल्ली, स्पाडोप्टेरा अमेरिकन इल्ली, वेगन की इल्ली, तथा लाखा आदि का पूर्णतः नियन्त्रण करता है और अधिक समय तक फसलों को सुरक्षित रखता है।`,
            dosage: "25 से 50 एम.एल. प्रति पम्प",
            Packaging: "250ml, 500ml, 1 Ltr.",
            image: Danger,
          },
          {
            id: 62,
            name: "GLO PRID",
            scientificName:"ACETAMIPRID 20% SP",
            category: "Insecticides/Pesticides",
            description: `यह एक घुलनशील पाउडर है, जो मुख्यतः कपास एवं अन्य फसलों एवं सब्जियों पर होने वाले कीट प्रकोप पर नियत्रंण करता है`,
            dosage: "20 ग्राम प्रति पम्प",
            Packaging: "100gm. 250gm",
            image: prod62Img,
          },
          {
            id: 63,
            name: "TRILL",
            scientificName:"BIFENTHRIN 10% E.C.",
            category: "Insecticides/Pesticides",
            description: `पेट और संपर्क कार्रवाई से कीड़ों को प्रभावित करता है और कीड़ों के तंत्रिका तंत्र पर कार्य करता है और सोडियम चैनल के साथ बातचीत करके न्यूरॉन्स के फंक्शन को डिसब्रब करता है. पैडी -स्टेम बोरर, लीफ फोल्डर और हरा लीफ हॉपर कॉटन बोल वर्म, व्हाइटफ्लाई गन्ना - टर्माइट`,
            dosage: "200 से 250 एम.एल. प्रति एकड़",
            Packaging: "250ml, 500ml एवं 1 Ltr.",
            image: prod63Img,
          },
          {
            id: 64,
            name: "ROLEX",
            scientificName:"MITICIDE",
            category: "Insecticides/Pesticides",
            description: `यह एक उच्च कक्ष की जैविक टेक्नोलोजीकल संशोधन आधारित प्रोडक्ट है। जिसमें खास प्रकार के जैविक घटक है जो बहुत शक्तिशाली कधीशीनाशक एवं कीटनाशक तरीके से काम करता है। इसके छिड़काव के बाद बहुत लम्बे समय के लिए सभी प्रकार के थ्रिप्स, सफेद मकड़ी लाल मकड़ी अन्य चूसक प्रकार के कीट, लीफमायनर्स इत्यादि को मारकर फसल को बचाता है। `,
            dosage: "20-25 एम.एल. प्रति पम्प",
            Packaging: "100ml, 250ml",
            image: prod64Img,
          },
          {
            id: 65,
            name: "GITHAL",
            scientificName:"CHLORPYRIFOS 20% EC",
            category: "Insecticides/Pesticides",
            description: `इसके प्रयोग से मिर्च व सब्जियों पर होने वाले कीटों की रोकथाम होती है। यह एक बहुउपयोगी कीटनशाक है। जो सुण्डियों जैसे : अमरीकन सुण्डी, चित्तीदार सुण्डी, और धान के तना छेदक, पत्ता लपेट सुण्डी, जमीन में पाये जाने वाले हानिकारक कीड़ो एवं दीमक को लंबे समय तक नियंत्रित करता है।`,
            dosage: "50 एम.एल. प्रति पम्प",
            Packaging: "1 Ltr. 500ml",
            image: prod65Img,
          },
          {
            id: 66,
            name: "SELECT",
            scientificName:"Quinalphos 25% EC",
            category: "Insecticides/Pesticides",
            description: `एक व्यापक स्पेक्ट्रम ऑर्गेनो-फॉस्फेटिक कीटनाशक है जिसमें 25% w/v क्विनालफोस होता है, पायसीकारी सांद्रण के रूप में। इसमें गतिविधि का व्यापक स्पेक्ट्रम है और कपास और तना छेदक, पत्ती फोल्डर, हरी पत्ती हॉपर, चावल पर हिस्पा पर बॉलवर्म के खिलाफ अच्छी प्रारंभिक और अवशिष्ट विषाक्तता है।`,
            dosage: "30-50 एम.एल. प्रति पम्प",
            Packaging: "1Ltr. एवं 500 ml",
            image: prod66Img,
          },
          {
            id: 67,
            name: "GLOVEG",
            scientificName:"DIAFENTHIURON 50% WP",
            category: "Insecticides/Pesticides",
            description: `
थियोरिया समूह का एक कीटनाशक, संपर्क और पेट क्रिया द्वारा एक कीटनाशक और एसारिसाइड के रूप में कार्य करता है। उत्पाद कुछ ओविसाइडल क्रिया भी दिखाता है। इसका उपयोग विभिन्न फसलों में सफेद मक्खी और अन्य चूसने वाले कीटों के साथ-साथ घुन को नियंत्रित करने के लिए किया जाता है।`,
            dosage: "25 ग्राम प्रति पम्प",
            Packaging: "25 gm",
            image: prod67Img,
          },
          {
            id: 68,
            name: "THAI-71",
            scientificName:"Ammonium Salt of Glyphosate 71% SG",
            category: "Herbicides",
            description: `
अपने मूल्यवान ग्राहकों को अत्यधिक संतुष्टि प्रदान करने के उद्देश्य से, हमने गुणवत्ता परीक्षित ग्लाइफोसेट 71% एसजी की पेशकश करने में महत्वपूर्ण भूमिका निभाई है। प्रदान किया गया उत्पाद उन्नत प्रसंस्करण इकाई में हमारे कुशल पेशेवरों द्वारा उत्कृष्ट ग्रेड रसायन का उपयोग करके तैयार किया गया है। फसल के रूप में जाना जाता है, यह उत्पाद चौड़ी पत्ती वाले सभी तरह की फसलो के खरपतवारों को मारने के लिए आदर्श है।`,
            dosage: "100 ग्राम प्रति पम्प / 1 किलो प्रति एकड़",
            Packaging: "100gm",
            image: THAI71,
          },
          {
            id: 69,
            name: "WEED CLEANER",
            scientificName:"2,4-D Ethyl Ester 38% E.C.",
            category: "Herbicides",
            description: `
यह कई फसलों में चौड़ी पत्ती वाले खरपतवारों के नियंत्रण के लिए एक सुरक्षित और विस्तृत स्पेक्ट्रम खरपतवारनाशी है। यह फेनोक्सीएसेटिक समूह का चयनात्मक, प्रणालीगत खरपतवारनाशी है। चौड़ी पत्ती बाले खरपतवारों को प्रभावी ढंग से नियंत्रित करने के अलावा, ये साइपरस एसपी को भी नियंत्रित करते हैं। यह पत्तियों और जड़ों द्वारा अवशोषित किया जाता है और खरपतवार पौधों में स्थानांतरित हो जाता है। आवेदन के समय मिट्टी में पर्याप्त नमी सुनिश्चित करें। इसे बुवाई/रोपण के 30-40 दिनों के बीच लगाना चाहिए।`,
            dosage: "300 से 500 एम.एल. प्रति एकड़",
            Packaging: "200 ml, 400 ml, 1 Ltr.",
            image: prod72Img,
          },
          {
            id: 70,
            name: "WEED STOPER",
            scientificName:"2, 4-D AMINE SALT 58% SL",
            category: "Herbicides",
            description: `व्यापक पत्ती खरपतवार को प्रभावी ढंग से नियंत्रित करने के अलावा, ये साइपरस एसपी को भी नियंत्रित करते हैं.

यह पत्तियों और जड़ों से अब्जॉर्ब होता है और खरपतवार के पौधों में बदल जाता है.

वीडमर या वीडमर सुपर की सिफारिश की गई खुराक के साथ फसलों पर कोई प्रतिकूल प्रभाव नहीं पड़ता है.`,
            dosage: "300 से 500 एम.एल. प्रति एकड़",
            Packaging: "200 ml, 400 ml, 1 Ltr.",
            image: prod73Img,
          },
          {
            id: 71,
            name: "SINGHAM",
            scientificName:"HUMIC ACID 5% + FULVIC 5% + SEAWEED EXTRACT 5%",
            category: "Plant Growth Promoter",
            description: `
सिंघम ह्युमिक एसिड आधारित एक प्राकृतिक पौध व उपज वृद्धिकारक उत्पाद है, जो जैव वैज्ञानिक विधि से प्राकृतिक स्रोतों से प्राप्त किया गया है। इसको फसल पर छिड़‌काव व मिट्टी के उपचार दोनों प्रकार से उपयोग के लिए बनाया गया है। यह मिट्टी को उपजाऊ बनाता है, व मिट्टी में भुरभुरापन लाता है। मिट्टी से उपस्थित पौषक तत्वों द्वारा पौधों को सरलता से उपलब्ध कराता है।`,
            dosage: "40-50 एम.एल प्रति पम्प",
            Packaging: "500ml, 1 Ltr.",
            image: prod74Img,
          },
          {
            id: 72,
            name: "MAHABALI",
            scientificName:"HUMIC ACID 5% + FULVIC ACID 5% + SEAWEED EXTRACT 5%",
            category: "Plant Growth Promoter",
            description: `महाबली ह्युमिक एसिड आधारित एक प्राकृतिक पौध व उपज वृद्धिकारक उत्पाद है, जो जैव वैज्ञानिक विधि से प्राकृतिक स्रोतों से प्राप्त किया गया है। इसका फसल पर छिड़‌काव व मिट्टी के उपचार दोनों प्रकार से उपयोग के लिए बनाया गया है। यह मिट्टी को उपजाऊ बनाता है व मिट्टी में भुरभुरापन लाता है। मिट्टी में उपस्थित पौषक तत्वों द्वारा पौधों को सरलता से उपलब्ध कराता है।`,
            dosage: "50 से 60 एम.एल. प्रति पम्प",
            Packaging: "500ml, 1 Ltr.",
            image: prod75Img,
          },
           {
            id: 73,
             name: "RAFTAR",
             scientificName:"BIOSTIMULANT",
            category: "Plant Growth Promoter",
            description: `रफ्तार ब्रासिनोलाइट्स आधारित फसल पर छिड़काव के लिए तैयार समग्र हार्मोन्स है। जो कपास दलहनी व तिलहनी फसलों, गन्ना, केला, सोयाबीन, चना, मिर्च, समस्त सब्जियों व फसलों के विकास और अधिक उपज के लिए विशेष रुप से तैयार किया गया है। यह फूलों व फलों की संख्या को बढ़ाता है, व उन्हे गिरने से रोकता है। सोयाबीन में अफलन की समस्या को बहुत हद तक कम करता है। पौधे में प्रकाशसंश्लेषण की क्रिया को बढ़ाता है।`,
            dosage: "10 से 15 एम.एल प्रति पम्प",
            Packaging: "250ml, 500ml, 1Ltr.",
            image: RAFTAR,
          },
            {
            id: 74,
              name: "MORE",
              scientificName:"HUMIC ACID 100% WATER SOLUBLE",
            category: "Plant Growth Promoter",
            description: `यह प्रोटीन्स, विटामिन्स, हार्मोन्स और एन्जाईमस और इसके साथ में आयरन, बोरान, कॉपर व जिंक का अनुठा मिश्रण है। पत्ती को नरम कर पत्ती की सिकुड़न को हटाता है। जैसे पत्ती को प्रेस करना फूलों को गिरने से बचाता है। फल सड़न की समस्या को खत्म करता है, शाखाएँ अधिक निकालता है एवं नया फुटाव करता है। लगातार हाईट प्रदान करता है, पौधे की भूख को बढ़ाता है।`,
            dosage: "20 ग्राम प्रति / पम्प",
            Packaging: "100gm",
            image: prod77Img,
          },
             {
            id: 75,
               name: "HOLD",
               scientificName:"HEXACONAZOLE 5% SC",
            category: "Fungicides",
            description: `होल्ड 5% ई. सी का एक नया रुप है। इसमें 5% हेक्साकोनाजोल सान्द्र निलंबन के रुप में मौजूद है यह टायाजोल समूह का अति उत्तम फफूंदनाशक है जो फसल को विभिन्न प्रकार के रोगों से बचाता है। इसका उपयोग धान सब्जियोंव फलों में पर्णचछंद भुरा पत्ती का धब्बा, अंगमारी रोग व आम चूर्णी आसित रोग के नियंत्रण के लिए किया जाता है`,
            dosage: "होल्ड की 400 एम. एल. मात्रा प्रति एकड़ 200 लीटर पानी में घोलकर करें।",
            Packaging: "500ml, 1 Ltr.",
            image: prod78Img,
          },
              {
            id: 76,
                name: "SILK",
                scientificName:"Silicon-Based Spreader ",
            category: "Spreaders/Activators",
            description: `सिलिकॉन आधारित स्प्रेडर स्टिकर सिल्क यह सिलिकोन बेस पर बना हुआ तरल पदार्थ है। इसे किसी भी कीटनाशक दवा के साथ मिला कर स्प्रे करने से दवा पौधे पर पूर्ण रुप से फैल जाती है जिसके परिणाम स्वरुप पौधे पर अटेक कम होता है`,
            dosage: "5 एम. एल. प्रति 15 लीटर पानी",
            Packaging: "50, 100, 250, 500 ml. एवं 1 Ltr.",
            image: SILK,
          },
               {
            id: 77,
                 name: "GLOVIT",
                 scientificName:"WETTING AGENT",
            category: "Spreaders/Activators",
            description: `यह किसी भी कीटनाशक फफूंदीनाशक, खरपतवार नाशक व अन्य एग्रीकेमीकल्स के अच्छे परिणाम दिलाने में सक्षम है। इसमें भिगाने की अद्भुत शक्ति है। एक समान घोल बनाने में सक्षम है। जिसमें हर छिड़काव में दवा का वितरण समान होता है। छिड़काव पौधे के वितरण विभिन्न अंगो में गहराई तक जाने में मदद करता है। जल्द सूखने में सहायक होता है पौधों पर दवाओं को फैलाने का कार्य करता है। समस्त फसलें जैसे सोयाबीन, गेहुँ, चना, मुंग, उड़द, अरहर, चावल, प्याज, लहसुन, अदरक, टमाटर, मिर्च, कपास, आलू आदि। मात्रा: 30-50 एम.एल प्रति पम्प`,
            dosage: "30-50 मिली प्रति पम्प",
            Packaging: "250ml, 500ml, 1Ltr.",
            image: prod80Img,
          },
                {
            id: 78,
                  name: "CYPER STAR PLUS",
                  scientificName:"CYPERMETHRIN 25% EC",
            category: "Insecticides/Pesticides",
            description: `यह सिंथेटिक पाइराथ्राइड ग्रुप का कीटनाशक है। यह अमेरिकन डोडे की सुण्डी, फल छेदक, तना छेदक तथा तने की मक्खी को प्रभावी रुप से नियंत्रित करता है यह सम्पर्क में आते ही कीटों को मार देता है। यह कीटों  की रोकथाम के लिये सोयाबीन, धान, कपास, चना व सब्जियों पर इस्तेमाल किया जाता है।`,
            dosage: "25-30 एम.एल. प्रति पम्प",
            Packaging: "1 Ltr. 500ml",
            image: prod81Img,
          },
                {
            id: 79,
                  name: "SORA",
                  scientificName:"Thiamethoxam 12.6% + Lambda-Cyhalothrin 9.5% ZC",
            category: "Insecticides/Pesticides",
            description: `
एक बहुपयोगी कीटनाशक मिश्रण है जो तीव्र-उदरीय तथा संस्पर्शी क्रियाशीलता रखता है इसका प्रयोग माहो, तेला, चर्दा, टिडर्ड की सुंडिया, चुरदा, अर्दकुंडलक, फल छेदक झिल्ली, सफेद मक्खी, स्टेम फ्लाई आदि में किया जाता है।`,
            dosage: "80 से 100 एम.एल. प्रति एकड़",
            Packaging: "250ml, 500ml, 1Ltr.",
            image: prod82Img,
          },
          {
            id: 80,
            name: "GURU",
            scientificName:"Plant Growth Promoter",
            category: "Plant Growth Promoter",
            description: `गुरू एक अद्‌भुत बाँयो ऑर्गेनिक उत्पाद हैं, जौ पौधों से कार्बनिक उर्जा लेकर बबले में पौर्ण की भूये चे आदरात पोषक तत्व उपलब्ध करवाता है व सूक्ष्म जड़ों की कई गुना ज्यादा जमीन में फैलता है। गृह का काम अस्फोरस की उपलब्धता को बढ़ाना है।`,
            dosage: "2.5 किलो प्रति एकड़",
            Packaging: "12 pack X 2.5 kg = 30 kg",
            image: prod83Img,
          },
          
          {
            id: 81,
            name: "BHUMIZ",
            scientificName: "सम्पूर्ण पोषण किट",
            category: "Plant Growth Promoter",
            description: `फसल की संपूर्ण वृद्धि और मिट्टी की सेहत के लिए विशेष रूप से तैयार संतुलित पोषण पैक।

📦 किट में शामिल तत्व:

✔ जिंक सल्फेट 33% मोनो – 5 किग्रा
✔ सल्फर 80% WDG – 3 किग्रा
✔ फेरस सल्फेट – 5 किग्रा
✔ मैग्नीशियम सल्फेट – 8 किग्रा
✔ मैंगनीज सल्फेट – 1 किग्रा
✔ ह्यूमिक एसिड – 1 किग्रा

🔹 कुल वजन: 25 किग्रा

🌿 उपयुक्त फसलें:
सभी प्रकार की फसलों के लिए उपयुक्त`,
            dosage: "1 किट प्रति एकड़",
            image: BHUMIZ,
            Packaging: "25 किग्रा",
          },
          {
            id: 82,
            name: "INACTIVE",
            scientificName: "डिक्लोसुलम 84% WDG",
            category: "Herbicides",
            description: `डिक्लोसुलम 84% WDG एक चयनात्मक (Selective) एवं प्रणालीगत (Systemic) शाकनाशी है, जिसे फसल उगने से पहले (Pre-Emergent) और प्रारंभिक अवस्था (Early Post-Emergence) में प्रयोग किया जाता है। यह मुख्य रूप से चौड़ी पत्ती वाले खरपतवार और मोथा (Sedges) को नियंत्रित करने में प्रभावी है।
          यह पौधों में ALS एंज़ाइम को अवरुद्ध करता है, जिससे खरपतवार की कोशिका विभाजन प्रक्रिया रुक जाती है और उनकी वृद्धि बंद हो जाती है।
          🔹 लक्षित फसलें: मुख्यतः सोयाबीन और मूंगफली (Groundnut)
          🔹 उपयोग का समय: बुवाई के 0 से 3 दिनों के भीतर (Pre-Emergence) प्रयोग करें।`,
            dosage: "लगभग 12.4 ग्राम प्रति एकड़",
            Packaging: "12.4 ग्राम",
            image: INACTIVE,
          },
          {
            id: 83,
            name: "Cargo",
            scientificName: "Triacontanol GR 0.05% Min",
            category: "Plant Growth Promoter",
            description: `यह एक ग्रैन्यूलर (दानेदार) प्लांट ग्रोथ रेगुलेटर (PGR) है, जिसमें न्यूनतम 0.05% w/w ट्राइकोंटानॉल मौजूद है।
यह फसल की उपज बढ़ाने, जड़ एवं तने के विकास को मजबूत करने और प्रकाश संश्लेषण (Photosynthesis) को बढ़ाने के लिए विशेष रूप से तैयार किया गया है।

यह पर्यावरण के अनुकूल और तेज़ असर करने वाला फॉर्मूलेशन है, जो कोशिका विभाजन (Cell Division) को प्रोत्साहित करता है।
इससे बेहतर फूल बनते हैं और फलों का गिरना कम होता है।

✅ प्रमुख लाभ:

✔ क्लोरोफिल की मात्रा बढ़ाता है
✔ एंजाइम गतिविधि में सुधार करता है
✔ पोषक तत्व एवं पानी के अवशोषण को बढ़ाता है
✔ जड़ और तने की वृद्धि को प्रोत्साहित करता है
✔ उत्पादन में उल्लेखनीय वृद्धि

📌 उपयोग विधि:

1️⃣ मिट्टी में प्रयोग करें — बुवाई के समय उर्वरकों के साथ मिलाकर या टॉप ड्रेसिंग के रूप में।

🌾 उपयुक्त फसलें:
धान, टमाटर, कप`,
            dosage: "5 किलो प्रति एकड़",
            Packaging: "5 kg",
            image: CARGO,
          },
          {
            id: 84,
            name: "MIRAN",
            scientificName: "00-52-34",
            category: "Liquid water soluble",
            description: `MIRAN 00-52-34 (MKP – मोनो पोटैशियम फॉस्फेट)

MIRAN 00-52-34 एक 100% पानी में पूरी तरह घुलनशील, नाइट्रोजन-रहित उर्वरक है, जिसमें फॉस्फोरस और पोटाश की उच्च मात्रा होती है। यह फर्टिगेशन (ड्रिप सिंचाई) और पर्णीय छिड़काव (Foliar Spray) दोनों के लिए उपयुक्त है। यह फूलों की बढ़वार को प्रोत्साहित करता है, फलों की गुणवत्ता में सुधार करता है और जड़ों के विकास को मजबूत बनाता है।

संरचना (Composition):
नाइट्रोजन (N) : 0%
फॉस्फोरस (P) : 52%
पोटाश (K) : 34%

उपयोग की विधि (Application Methods):
ड्रिप सिंचाई (फर्टिगेशन)

पत्तियों पर छिड़काव (Foliar Spray)

उपयुक्त समय (Timing):
अधिकतम फूल और फल विकास के लिए प्री-ब्लूम (फूल आने से पहले) और पोस्ट-ब्लूम (फूल आने के बाद) अवस्था में प्रयोग करें।`,
            dosage: "पर्णीय छिड़काव: 15–20 मि.ली. प्रति लीटर पानी में मिलाकर पत्तियों पर छिड़काव करें।",
            Packaging: "1 लीटर, 500 मि.ली.",
            image: MIRAN,
          },
          {
            id: 85,
            name: "AUXIL",
            scientificName: "19:19:19",
            category: "Liquid water soluble",
            description: `AUXIL (19:19:19)

यह पौधों को नाइट्रोजन, फॉस्फोरस और पोटाश समान मात्रा में प्रदान करता है। इसका उपयोग पौधों की प्रारंभिक वृद्धि अवस्था में करना चाहिए। इसका छिड़काव मुरझाई हुई या पीली पड़ी फसल को सुधारने में बहुत प्रभावी है। यह शाखाओं और फूलों की संख्या बढ़ाने में सहायक है। प्रारंभिक विकास चरण में फसलों को संतुलित पोषण प्रदान करता है। विशेष रूप से नर्सरी के पौधों और बढ़ते हुए पौधों की स्वस्थ शाकीय वृद्धि के लिए उपयोगी है। यह फूल और फल झड़ने से रोकता है, जिससे अधिक उत्पादन प्राप्त होता है।

1. संरचना (COMPOSITION):
नाइट्रोजन (N) : 19%
फॉस्फोरस (P) : 19%
टाश (K) : 19%`,
            dosage: "250–300 मि.ली. प्रति एकड़",
            Packaging: "1 लीटर, 500 मि.ली.",
            image: AUXIL,
          },
          {
            id: 86,
            name: "LOGIC",
            scientificName: "जिंक ऑक्साइड सस्पेंशन कॉन्सन्ट्रेट 39.5% Zn",
            category: "Liquid water soluble",
            description: `LOGIC – जिंक ऑक्साइड सस्पेंशन कॉन्सन्ट्रेट 39.5% Zn

LOGIC जिंक ऑक्साइड 39.5% Zn एक उच्च सघनता वाला, तरल फ्लोएबल उर्वरक है, जिसे फसलों में जिंक की कमी को दूर करने के लिए तैयार किया गया है। यह क्लोरोफिल निर्माण, एंजाइम सक्रियण और चयापचय वृद्धि (Metabolic Growth) जैसी महत्वपूर्ण पौध क्रियाओं के लिए आवश्यक सूक्ष्म पोषक तत्व (Micronutrient) प्रदान करता है।

यह पत्तियों द्वारा तेजी से अवशोषित होता है, शीघ्र प्रभाव दिखाता है और फसल उत्पादन में वृद्धि करने में सहायक है।

उपयोग (Application):

पर्णीय छिड़काव (Foliar Spray):
0.5 मि.ली. – 1.5 मि.ली. प्रति लीटर पानी में मिलाकर छिड़काव करें।

मिट्टी में प्रयोग :
500 मि.ली. – 1 लीटर प्रति एकड़।`,
            dosage:
              "पर्णीय छिड़काव: 0.5 मि.ली. – 1.5 मि.ली. प्रति लीटर पानी में। मिट्टी में प्रयोग: 500 मि.ली. – 1 लीटर प्रति एकड़।",
            Packaging: "1 लीटर, 500 मि.ली.",
            image: LOGIC,
          },
          {
            id: 87,
            name: "FLOTON",
            scientificName: "कैल्शियम मैग्नीशियम नाइट्रेट",
            category: "Liquid water soluble",
            description: `FLOTON एक अत्यधिक घुलनशील और तेजी से प्रभाव दिखाने वाला उर्वरक है, जो पौधों को आवश्यक कैल्शियम, नाइट्रोजन और मैग्नीशियम प्रदान करता है। यह क्लोरोफिल निर्माण, प्रकाश संश्लेषण (Photosynthesis) और मजबूत व स्वस्थ पौध वृद्धि में सहायक है।

यह फर्टिगेशन (ड्रिप सिंचाई) और पर्णीय छिड़काव दोनों के लिए उपयुक्त है। यह ब्लॉसम एंड रॉट (फल सड़न) जैसी पोषक तत्वों की कमी को रोकने में मदद करता है और फल, सब्जियों तथा सजावटी पौधों की गुणवत्ता में सुधार करता है।

उपयोग की विधि 
फर्टिगेशन (ड्रिप सिंचाई)

मिट्टी में ड्रेंचिंग

पत्तियों पर छिड़काव (Foliar Spray)`,
            dosage: "250–300 मि.ली. प्रति एकड़",
            Packaging: "1 लीटर, 500 मि.ली.",
            image: FLOTON,
          },
          {
            id: 88,
            name: "ULTRA",
            scientificName: "बोरॉन एथेनोलामाइन 10%",
            category: "Liquid water soluble",
            description: `ULTRA बोरॉन एथेनोलामाइन 10% एक अत्यधिक घुलनशील तरल सूक्ष्म पोषक तत्व (Micronutrient) उर्वरक है, जिसमें 10% बोरॉन उपलब्ध होता है। बोरॉन कोशिका भित्ति (Cell Wall) निर्माण, पराग अंकुरण (Pollen Germination) और फल सेट (Fruit Set) के लिए अत्यंत आवश्यक तत्व है।

यह बोरॉन की कमी से होने वाली समस्याओं जैसे तनों में दरार, फल सड़न और कमजोर विकास को दूर करता है।

कमी की पूर्ति (Deficiency Fix): हॉलो स्टेम (अंदर से खोखला तना) और फल फटने जैसी बोरॉन की कमी को प्रभावी रूप से नियंत्रित करता है।`,
            dosage: "200 मि.ली. प्रति एकड़",
            Packaging: "1 लीटर, 500 मि.ली.",
            image: ULTRA,
          },
        ],
      },
      testimonial: {
        testimonialTitle: "हमारे ग्राहक क्या कहते हैं?",
        reasons: [
          {
            id: 1,
            name: "Pintu Rajput",
            role: "किसान",
            content:
              "Globe International Crop Science के कीटनाशकों ने मेरी फसल को नुकसानदायक कीटों से बचाया। अब मेरी फसल ज्यादा स्वस्थ और मजबूत है!",
          },
          {
            id: 2,
            name: "Amit Sharma",
            role: "किसान",
            content:
              "पहले कीटों के कारण फसलें खराब हो जाती थीं, लेकिन GICS के पेस्टीसाइड्स से अब फसलें सुरक्षित और ज्यादा उपज दे रही हैं!",
          },
          {
            id: 3,
            name: "Sunil Yadav",
            role: "किसान",
            content:
              "कीटनाशकों का सही चुनाव बहुत जरूरी है, और Globe International Crop Science के 'Corex' और 'Force-505' प्रोडक्ट्स ने मेरी फसल को बेहतरीन सुरक्षा दी है।",
          },
          {
            id: 4,
            name: "Rakesh Verma",
            role: "किसान",
            content:
              "अब मुझे कीटों की चिंता नहीं होती! GICS के पेस्टीसाइड्स से मेरी फसल को सुरक्षित और स्वस्थ रखने में मदद मिली।",
          },
          {
            id: 5,
            name: "Balwan Singh Rajput",
            role: "किसान",
            content:
              "फसल में फफूंद लगने की समस्या थी, लेकिन GICS का 'HOLD' फफूंदनाशकों ने इसे पूरी तरह से खत्म कर दिया। अब पैदावार पहले से बेहतर है!",
          },
          {
            id: 6,
            name: "Mahendra Sharma",
            role: "किसान",
            content:
              "फंगस से खराब होती फसलें अब बीते दिनों की बात है। Globe International Crop Science के फंगीसाइड्स ने फसल को बचाया!",
          },
          {
            id: 7,
            name: "Harish Mehta",
            role: "किसान",
            content:
              "बिना सही फंगीसाइड के अच्छी फसल की उम्मीद करना मुश्किल था, लेकिन 'STODIA' ने मेरी खेती को सुरक्षित और उत्पादक बना दिया!",
          },
          {
            id: 8,
            name: "Suresh Tiwari",
            role: "किसान",
            content:
              "अब मेरी फसल को कोई फंगस नुकसान नहीं पहुंचा सकता! GICS के फंगीसाइड्स का असर बेहतरीन है।",
          },
          {
            id: 9,
            name: "Arjun Kourav",
            role: "किसान",
            content:
              "फसलों में खरपतवार बहुत तेजी से बढ़ते थे, लेकिन GICS के 'TAKITO' और 'TEMBO-G' हर्बीसाइड्स ने इस समस्या का समाधान कर दिया!",
          },
          {
            id: 10,
            name: "Vivek Malviya",
            role: "किसान",
            content:
              "पहले खरपतवार हटाने में बहुत समय और मेहनत लगती थी, लेकिन अब GICS के हर्बीसाइड्स से खेत साफ और उपजाऊ रहते हैं।",
          },
          {
            id: 11,
            name: "Rajendra Patel",
            role: "किसान",
            content:
              "खरपतवार अब मेरी फसलों की ग्रोथ में रुकावट नहीं बनते! GICS का 'Weed Cleaner' हर्बीसाइड्स का असर बहुत अच्छा है।",
          },
          {
            id: 12,
            name: "Anil Gupta",
            role: "किसान",
            content:
              "Globe International Crop Science के हर्बीसाइड्स ने मेरे खेतों को खरपतवार मुक्त बना दिया, जिससे उत्पादन बढ़ गया!",
          },
          {
            id: 13,
            name: "Prashant Kourav",
            role: "किसान",
            content:
              "GICS के 'Glopaushak', 'More', 'Singham' प्लांट ग्रोथ रेगुलेटर्स ने मेरी फसल की ग्रोथ को तेज और संतुलित किया। पौधे अब ज्यादा हरे-भरे और स्वस्थ दिखते हैं!",
          },
          {
            id: 14,
            name: "Ansul Joshi",
            role: "किसान",
            content:
              "मेरी फसल पहले कमजोर और धीमी थी, लेकिन GICS के ग्रोथ रेगुलेटर्स से अब बेहतर उत्पादन मिल रहा है।",
          },
          {
            id: 15,
            name: "Atul Jain",
            role: "किसान",
            content:
              "अगर आप अपनी फसल को तेजी से बढ़ता और मजबूत देखना चाहते हैं, तो GICS के ग्रोथ रेगुलेटर्स सबसे बेस्ट हैं!",
          },
          {
            id: 16,
            name: "Manoj Singh",
            role: "किसान",
            content:
              "Globe International Crop Science के ग्रोथ रेगुलेटर्स से मेरी फसल की जड़ें मजबूत हुईं और उपज में जबरदस्त बढ़ोतरी हुई!",
          },
          {
            id: 17,
            name: "Raghunandan Rajput",
            role: "किसान",
            content:
              "Globe International Crop Science के उत्पाद हमेशा भरोसेमंद और उच्च गुणवत्ता वाले होते हैं। इनकी मदद से मेरी फसलें सुरक्षित और उत्पादक बनी हैं!",
          },
          {
            id: 18,
            name: "Rohit Kushwah",
            role: "किसान",
            content:
              "कृषि के लिए सबसे अच्छे समाधान GICS के पास हैं। उनके उत्पादों का असर वाकई शानदार है!",
          },
          {
            id: 19,
            name: "Ranjeet Raghuvanshi",
            role: "किसान",
            content:
              "मैं सालों से GICS के प्रोडक्ट्स इस्तेमाल कर रहा हूँ और हर बार बेहतरीन रिजल्ट मिले हैं। खेती के लिए इनसे बेहतर कोई नहीं!",
          },
          {
            id: 20,
            name: "Shiv Kumar",
            role: "किसान",
            content:
              "Globe International Crop Science ने किसानों के लिए खेती को आसान और ज्यादा फायदेमंद बना दिया है। उनके उत्पाद पूरी तरह से भरोसेमंद हैं!",
          },
        ],
      },
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "en", // Default language
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

export default i18n;
